import '@polkadot/api';
import { ethers } from 'ethers';
import { prodRelayPolkadot, prodRelayKusama } from '@polkadot/apps-config/endpoints';

//  derrived from https://github.com/kodadot/packages/blob/main/minimark/src/common/types.ts
var Version;
(function (Version) {
  Version[Version["V1"] = 0] = "V1";
  Version[Version["V3"] = 1] = "V3";
})(Version || (Version = {}));

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

// Used to inform user, that Parachain they wish to use has not yet implemented full XCM Support
var NoXCMSupportImplementedError = /*#__PURE__*/function (_Error) {
  _inherits(NoXCMSupportImplementedError, _Error);
  var _super = _createSuper(NoXCMSupportImplementedError);
  function NoXCMSupportImplementedError(node) {
    var _this;
    _classCallCheck(this, NoXCMSupportImplementedError);
    _this = _super.call(this, "No XCM support implemented for ".concat(node, " node yet."));
    _this.name = 'NoXCMSupportImplemented';
    return _this;
  }
  return _createClass(NoXCMSupportImplementedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var Acala$2 = {
	paraId: 2000,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "aUSD",
			decimals: 12
		},
		{
			symbol: "ACA",
			decimals: 12
		},
		{
			symbol: "TAP",
			decimals: 12
		},
		{
			symbol: "LcDOT",
			decimals: 10
		},
		{
			symbol: "LDOT",
			decimals: 10
		},
		{
			symbol: "DOT",
			decimals: 10
		}
	],
	otherAssets: [
		{
			assetId: "10",
			symbol: "UNQ",
			decimals: 18
		},
		{
			assetId: "0",
			symbol: "tDOT",
			decimals: 10
		},
		{
			assetId: "8",
			symbol: "EQD",
			decimals: 9
		},
		{
			assetId: "4",
			symbol: "INTR",
			decimals: 10
		},
		{
			assetId: "6",
			symbol: "WETH",
			decimals: 18
		},
		{
			assetId: "0x07df96d1341a7d16ba1ad431e2c847d978bc2bce",
			symbol: "USDCet",
			decimals: 6
		},
		{
			assetId: "2",
			symbol: "ASTR",
			decimals: 18
		},
		{
			assetId: "9",
			symbol: "PHA",
			decimals: 12
		},
		{
			assetId: "1",
			symbol: "PARA",
			decimals: 12
		},
		{
			assetId: "0xf4c723e61709d90f89939c1852f516e373d418a8",
			symbol: "APE",
			decimals: 18
		},
		{
			assetId: "0",
			symbol: "GLMR",
			decimals: 18
		},
		{
			assetId: "5",
			symbol: "WBTC",
			decimals: 8
		},
		{
			assetId: "0x54a37a01cd75b616d63e0ab665bffdb0143c52ae",
			symbol: "DAI",
			decimals: 18
		},
		{
			assetId: "11",
			symbol: "CRU",
			decimals: 12
		},
		{
			assetId: "0x5a4d6acdc4e3e5ab15717f407afe957f7a242578",
			symbol: "WETH",
			decimals: 18
		},
		{
			assetId: "7",
			symbol: "EQ",
			decimals: 9
		},
		{
			assetId: "0xc80084af223c8b598536178d9361dc55bfda6818",
			symbol: "WBTC",
			decimals: 8
		},
		{
			assetId: "3",
			symbol: "IBTC",
			decimals: 8
		}
	]
};
var Astar$2 = {
	paraId: 2006,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "ASTR",
			decimals: 18
		}
	],
	otherAssets: [
		{
			assetId: "100002",
			symbol: "xcATOM",
			decimals: 6
		},
		{
			assetId: "18446744073709551623",
			symbol: "BNC",
			decimals: 12
		},
		{
			assetId: "1325",
			symbol: "MASTR",
			decimals: 18
		},
		{
			assetId: "18446744073709551619",
			symbol: "GLMR",
			decimals: 18
		},
		{
			assetId: "1337",
			symbol: "XC20",
			decimals: 18
		},
		{
			assetId: "1334",
			symbol: "TOK",
			decimals: 18
		},
		{
			assetId: "862812",
			symbol: "CUBO",
			decimals: 9
		},
		{
			assetId: "1328",
			symbol: "ALGM",
			decimals: 18
		},
		{
			assetId: "1333",
			symbol: "ASTR",
			decimals: 20
		},
		{
			assetId: "18446744073709551625",
			symbol: "CLV",
			decimals: 18
		},
		{
			assetId: "18446744073709551620",
			symbol: "IBTC",
			decimals: 8
		},
		{
			assetId: "18446744073709551621",
			symbol: "INTR",
			decimals: 10
		},
		{
			assetId: "18446744073709551622",
			symbol: "PHA",
			decimals: 12
		},
		{
			assetId: "1327",
			symbol: "CHAI",
			decimals: 18
		},
		{
			assetId: "1338",
			symbol: "TST",
			decimals: 18
		},
		{
			assetId: "1326",
			symbol: "aASTR",
			decimals: 18
		},
		{
			assetId: "100001",
			symbol: "xcINJ",
			decimals: 18
		},
		{
			assetId: "340282366920938463463374607431768211455",
			symbol: "DOT",
			decimals: 10
		},
		{
			assetId: "1335",
			symbol: "MDOT",
			decimals: 10
		},
		{
			assetId: "868367",
			symbol: "VSC",
			decimals: 9
		},
		{
			assetId: "18446744073709551616",
			symbol: "ACA",
			decimals: 12
		},
		{
			assetId: "1339",
			symbol: "TST",
			decimals: 18
		},
		{
			assetId: "18446744073709551624",
			symbol: "vDOT",
			decimals: 10
		},
		{
			assetId: "18446744073709551618",
			symbol: "LDOT",
			decimals: 10
		},
		{
			assetId: "18446744073709551630",
			symbol: "HDX",
			decimals: 12
		},
		{
			assetId: "18446744073709551617",
			symbol: "aUSD",
			decimals: 12
		},
		{
			assetId: "1336",
			symbol: "TDOT",
			decimals: 18
		},
		{
			assetId: "1329",
			symbol: "PPC",
			decimals: 8
		},
		{
			assetId: "18446744073709551626",
			symbol: "vsDOT",
			decimals: 10
		},
		{
			assetId: "18446744073709551629",
			symbol: "EQD",
			decimals: 9
		},
		{
			assetId: "4294969280",
			symbol: "USDT",
			decimals: 6
		},
		{
			assetId: "1324",
			symbol: "ASTR",
			decimals: 20
		},
		{
			assetId: "18446744073709551628",
			symbol: "EQ",
			decimals: 9
		},
		{
			assetId: "18446744073709551627",
			symbol: "RING",
			decimals: 18
		},
		{
			assetId: "1330",
			symbol: "MMC",
			decimals: 2
		},
		{
			assetId: "1331",
			symbol: "sDOT",
			decimals: 10
		},
		{
			assetId: "1332",
			symbol: "sDOT",
			decimals: 10
		}
	]
};
var BifrostPolkadot$2 = {
	paraId: 2030,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "ASG",
			decimals: 18
		},
		{
			symbol: "BNC",
			decimals: 12
		},
		{
			symbol: "KUSD",
			decimals: 12
		},
		{
			symbol: "DOT",
			decimals: 10
		},
		{
			symbol: "KSM",
			decimals: 12
		},
		{
			symbol: "ETH",
			decimals: 18
		},
		{
			symbol: "KAR",
			decimals: 12
		},
		{
			symbol: "ZLK",
			decimals: 12
		},
		{
			symbol: "PHA",
			decimals: 12
		},
		{
			symbol: "RMRK",
			decimals: 10
		},
		{
			symbol: "MOVR",
			decimals: 18
		}
	],
	otherAssets: [
	]
};
var Bitgreen$2 = {
	paraId: 2048,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "BBB",
			decimals: 18
		}
	],
	otherAssets: [
	]
};
var Centrifuge$2 = {
	paraId: 2031,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "CFG",
			decimals: 18
		}
	],
	otherAssets: [
		{
			assetId: "3",
			symbol: "aUSD",
			decimals: 12
		},
		{
			assetId: "1",
			symbol: "USDT",
			decimals: 6
		},
		{
			assetId: "4",
			symbol: "GLMR",
			decimals: 18
		},
		{
			assetId: "2",
			symbol: "xcUSDC",
			decimals: 6
		}
	]
};
var Clover$2 = {
	paraId: 2002,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "CLV",
			decimals: 18
		}
	],
	otherAssets: [
		{
			assetId: "11",
			symbol: "PARA",
			decimals: 12
		},
		{
			assetId: "12",
			symbol: "ASTR",
			decimals: 18
		}
	]
};
var ComposableFinance$2 = {
	paraId: 2019,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "LAYR",
			decimals: 12
		}
	],
	otherAssets: [
	]
};
var Darwinia$2 = {
	paraId: 2046,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "RING",
			decimals: 18
		}
	],
	otherAssets: [
	]
};
var HydraDX$2 = {
	paraId: 2034,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "HDX",
			decimals: 12
		}
	],
	otherAssets: [
	]
};
var Interlay$2 = {
	paraId: 2032,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "INTR",
			decimals: 10
		},
		{
			symbol: "IBTC",
			decimals: 8
		},
		{
			symbol: "DOT",
			decimals: 10
		},
		{
			symbol: "KINT",
			decimals: 12
		},
		{
			symbol: "KBTC",
			decimals: 8
		},
		{
			symbol: "KSM",
			decimals: 12
		}
	],
	otherAssets: [
		{
			assetId: "1",
			symbol: "LDOT",
			decimals: 10
		},
		{
			assetId: "2",
			symbol: "USDT",
			decimals: 6
		}
	]
};
var Kylin$2 = {
	paraId: 2052,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "KYL",
			decimals: 18
		}
	],
	otherAssets: [
		{
			assetId: "1",
			symbol: "DOT",
			decimals: 0
		}
	]
};
var Litentry$2 = {
	paraId: 2013,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "LIT",
			decimals: 12
		}
	],
	otherAssets: [
	]
};
var Moonbeam$2 = {
	paraId: 2004,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "GLMR",
			decimals: 18
		}
	],
	otherAssets: [
		{
			assetId: "125699734534028342599692732320197985871",
			symbol: "RING",
			decimals: 18
		},
		{
			assetId: "187224307232923873519830480073807488153",
			symbol: "EQD",
			decimals: 9
		},
		{
			assetId: "190590555344745888270686124937537713878",
			symbol: "EQ",
			decimals: 9
		},
		{
			assetId: "224077081838586484055667086558292981199",
			symbol: "ASTR",
			decimals: 18
		},
		{
			assetId: "110021739665376159354538090254163045594",
			symbol: "aUSD",
			decimals: 12
		},
		{
			assetId: "311091173110107856861649819128533077277",
			symbol: "USDT",
			decimals: 6
		},
		{
			assetId: "120637696315203257380661607956669368914",
			symbol: "IBTC",
			decimals: 8
		},
		{
			assetId: "101170542313601871197860408087030232491",
			symbol: "INTR",
			decimals: 10
		},
		{
			assetId: "165823357460190568952172802245839421906",
			symbol: "BNC",
			decimals: 12
		},
		{
			assetId: "32615670524745285411807346420584982855",
			symbol: "PARA",
			decimals: 12
		},
		{
			assetId: "42259045809535163221576417993425387648",
			symbol: "DOT",
			decimals: 10
		},
		{
			assetId: "224821240862170613278369189818311486111",
			symbol: "ACA",
			decimals: 12
		},
		{
			assetId: "132685552157663328694213725410064821485",
			symbol: "PHA",
			decimals: 12
		}
	]
};
var Parallel$2 = {
	paraId: 2012,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "PARA",
			decimals: 12
		}
	],
	otherAssets: [
		{
			assetId: "6002",
			symbol: "LP-DOT/PARA",
			decimals: 12
		},
		{
			assetId: "6007",
			symbol: "LP-DOT/cDOT-8/15",
			decimals: 12
		},
		{
			assetId: "110",
			symbol: "LDOT",
			decimals: 10
		},
		{
			assetId: "1001",
			symbol: "sDOT",
			decimals: 10
		},
		{
			assetId: "120",
			symbol: "INTR",
			decimals: 10
		},
		{
			assetId: "108",
			symbol: "ACA",
			decimals: 12
		},
		{
			assetId: "200070014",
			symbol: "cDOT-7/14",
			decimals: 10
		},
		{
			assetId: "6009",
			symbol: "LP-PHA/PARA",
			decimals: 12
		},
		{
			assetId: "101",
			symbol: "DOT",
			decimals: 10
		},
		{
			assetId: "6005",
			symbol: "LP-DOT/cDOT-7/14",
			decimals: 12
		},
		{
			assetId: "200080015",
			symbol: "cDOT-8/15",
			decimals: 10
		},
		{
			assetId: "122",
			symbol: "IBTC",
			decimals: 8
		},
		{
			assetId: "6016",
			symbol: "LP-INTR/PARA",
			decimals: 12
		},
		{
			assetId: "6004",
			symbol: "LP-DOT/cDOT-6/13",
			decimals: 12
		},
		{
			assetId: "200110018",
			symbol: "cDOT-11/18",
			decimals: 10
		},
		{
			assetId: "6013",
			symbol: "LP-PARA/cDOT-8/15",
			decimals: 12
		},
		{
			assetId: "104",
			symbol: "AUSD",
			decimals: 12
		},
		{
			assetId: "6003",
			symbol: "LP-DOT/sDOT",
			decimals: 12
		},
		{
			assetId: "6017",
			symbol: "LP-IBTC/PARA",
			decimals: 12
		},
		{
			assetId: "102",
			symbol: "USDT",
			decimals: 6
		},
		{
			assetId: "106",
			symbol: "lcDOT",
			decimals: 10
		},
		{
			assetId: "114",
			symbol: "GLMR",
			decimals: 18
		},
		{
			assetId: "6008",
			symbol: "LP-GLMR/PARA",
			decimals: 12
		},
		{
			assetId: "130",
			symbol: "CLV",
			decimals: 18
		},
		{
			assetId: "4294957296",
			symbol: "DOT_U",
			decimals: 10
		},
		{
			assetId: "112",
			symbol: "ASTR",
			decimals: 18
		},
		{
			assetId: "200100017",
			symbol: "cDOT-10/17",
			decimals: 10
		},
		{
			assetId: "6011",
			symbol: "LP-lcDOT/PARA",
			decimals: 12
		},
		{
			assetId: "6012",
			symbol: "LP-PARA/cDOT-7/14",
			decimals: 12
		},
		{
			assetId: "6010",
			symbol: "LP-USDT/PARA",
			decimals: 12
		},
		{
			assetId: "200060013",
			symbol: "cDOT-6/13",
			decimals: 10
		},
		{
			assetId: "115",
			symbol: "PHA",
			decimals: 12
		},
		{
			assetId: "200090016",
			symbol: "cDOT-9/16",
			decimals: 10
		},
		{
			assetId: "6014",
			symbol: "LP-ACA/PARA",
			decimals: 12
		},
		{
			assetId: "6006",
			symbol: "LP-PARA/cDOT-6/13",
			decimals: 12
		},
		{
			assetId: "6015",
			symbol: "LP-LDOT/PARA",
			decimals: 12
		}
	]
};
var Statemint$2 = {
	paraId: 1000,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "DOT",
			decimals: 10
		}
	],
	otherAssets: [
		{
			assetId: "100",
			symbol: "WETH",
			decimals: 18
		},
		{
			assetId: "123",
			symbol: "123",
			decimals: 20
		},
		{
			assetId: "10",
			symbol: "BEAST",
			decimals: 8
		},
		{
			assetId: "4",
			symbol: "EFI",
			decimals: 18
		},
		{
			assetId: "21",
			symbol: "WBTC",
			decimals: 8
		},
		{
			assetId: "999",
			symbol: "gold",
			decimals: 20
		},
		{
			assetId: "101",
			symbol: "DOTMA",
			decimals: 0
		},
		{
			assetId: "11",
			symbol: "web3",
			decimals: 18
		},
		{
			assetId: "6",
			symbol: "LPHP",
			decimals: 2
		},
		{
			assetId: "77",
			symbol: "TRQ",
			decimals: 18
		},
		{
			assetId: "2",
			symbol: "BTC",
			decimals: 20
		},
		{
			assetId: "868367",
			symbol: "VSC",
			decimals: 9
		},
		{
			assetId: "5",
			symbol: "PLX",
			decimals: 9
		},
		{
			assetId: "7",
			symbol: "lucky7",
			decimals: 20
		},
		{
			assetId: "1984",
			symbol: "USDt",
			decimals: 6
		},
		{
			assetId: "20090103",
			symbol: "BTC",
			decimals: 20
		},
		{
			assetId: "777",
			symbol: "777",
			decimals: 20
		},
		{
			assetId: "8",
			symbol: "JOE",
			decimals: 9
		},
		{
			assetId: "1000",
			symbol: "BRZ",
			decimals: 6
		},
		{
			assetId: "1",
			symbol: "no1",
			decimals: 20
		},
		{
			assetId: "3",
			symbol: "DOT",
			decimals: 20
		},
		{
			assetId: "1337",
			symbol: "USDC",
			decimals: 6
		},
		{
			assetId: "666",
			symbol: "DANGER",
			decimals: 8
		},
		{
			assetId: "9",
			symbol: "PINT",
			decimals: 12
		},
		{
			assetId: "862812",
			symbol: "CUBO",
			decimals: 9
		}
	]
};
var Altair$2 = {
	paraId: 2088,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "AIR",
			decimals: 18
		}
	],
	otherAssets: [
	]
};
var Amplitude$2 = {
	paraId: 2124,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "AMPE",
			decimals: 12
		}
	],
	otherAssets: [
	]
};
var Bajun$2 = {
	paraId: 2119,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "BAJU",
			decimals: 12
		}
	],
	otherAssets: [
	]
};
var Basilisk$2 = {
	paraId: 2090,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "BSX",
			decimals: 12
		}
	],
	otherAssets: [
		{
			assetId: "13",
			symbol: "DAI",
			decimals: 18
		},
		{
			assetId: "1",
			symbol: "KSM",
			decimals: 12
		},
		{
			assetId: "9",
			symbol: "USDCet",
			decimals: 6
		},
		{
			assetId: "16",
			symbol: "XRT",
			decimals: 9
		},
		{
			assetId: "14",
			symbol: "USDT",
			decimals: 6
		},
		{
			assetId: "2",
			symbol: "aUSD",
			decimals: 12
		},
		{
			assetId: "10",
			symbol: "wETH",
			decimals: 18
		},
		{
			assetId: "0",
			symbol: "BSX",
			decimals: 12
		},
		{
			assetId: "6",
			symbol: "TNKR",
			decimals: 12
		},
		{
			assetId: "11",
			symbol: "wBTC",
			decimals: 8
		},
		{
			assetId: "12",
			symbol: "wUSDT",
			decimals: 6
		}
	]
};
var BifrostKusama$2 = {
	paraId: 2001,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "BNC",
			decimals: 12
		},
		{
			symbol: "KUSD",
			decimals: 12
		},
		{
			symbol: "DOT",
			decimals: 10
		},
		{
			symbol: "KSM",
			decimals: 12
		},
		{
			symbol: "KAR",
			decimals: 12
		},
		{
			symbol: "ZLK",
			decimals: 18
		},
		{
			symbol: "PHA",
			decimals: 12
		},
		{
			symbol: "RMRK",
			decimals: 10
		},
		{
			symbol: "MOVR",
			decimals: 18
		}
	],
	otherAssets: [
	]
};
var Calamari$2 = {
	paraId: 2084,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "KMA",
			decimals: 12
		}
	],
	otherAssets: [
		{
			assetId: "21",
			symbol: "BNB",
			decimals: 18
		},
		{
			assetId: "26",
			symbol: "WBTC",
			decimals: 8
		},
		{
			assetId: "16",
			symbol: "USDC",
			decimals: 6
		},
		{
			assetId: "23",
			symbol: "BUSD",
			decimals: 18
		},
		{
			assetId: "9",
			symbol: "AUSD",
			decimals: 12
		},
		{
			assetId: "18",
			symbol: "LDO",
			decimals: 18
		},
		{
			assetId: "20",
			symbol: "MATIC",
			decimals: 18
		},
		{
			assetId: "8",
			symbol: "KAR",
			decimals: 12
		},
		{
			assetId: "10",
			symbol: "LKSM",
			decimals: 12
		},
		{
			assetId: "12",
			symbol: "KSM",
			decimals: 12
		},
		{
			assetId: "17",
			symbol: "ARB",
			decimals: 18
		},
		{
			assetId: "25",
			symbol: "APE",
			decimals: 18
		},
		{
			assetId: "13",
			symbol: "PHA",
			decimals: 12
		},
		{
			assetId: "22",
			symbol: "UNI",
			decimals: 18
		},
		{
			assetId: "24",
			symbol: "LINK",
			decimals: 18
		},
		{
			assetId: "19",
			symbol: "SHIB",
			decimals: 18
		},
		{
			assetId: "27",
			symbol: "WETH",
			decimals: 18
		},
		{
			assetId: "15",
			symbol: "DAI",
			decimals: 18
		},
		{
			assetId: "11",
			symbol: "MOVR",
			decimals: 18
		},
		{
			assetId: "14",
			symbol: "USDT",
			decimals: 6
		}
	]
};
var Crab$2 = {
	paraId: 2105,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "CRAB",
			decimals: 18
		}
	],
	otherAssets: [
	]
};
var CrustShadow$2 = {
	paraId: 2012,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "CSM",
			decimals: 12
		}
	],
	otherAssets: [
		{
			assetId: "16797826370226091782818345603793389938",
			symbol: "SDN",
			decimals: 18
		},
		{
			assetId: "108036400430056508975016746969135344601",
			symbol: "XRT",
			decimals: 9
		},
		{
			assetId: "173481220575862801646329923366065693029",
			symbol: "CRAB",
			decimals: 18
		},
		{
			assetId: "214920334981412447805621250067209749032",
			symbol: "AUSD",
			decimals: 12
		},
		{
			assetId: "232263652204149413431520870009560565298",
			symbol: "MOVR",
			decimals: 18
		},
		{
			assetId: "10810581592933651521121702237638664357",
			symbol: "KAR",
			decimals: 12
		},
		{
			assetId: "319623561105283008236062145480775032445",
			symbol: "BNC",
			decimals: 12
		}
	]
};
var Dorafactory$2 = {
	paraId: 2115,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "DORA",
			decimals: 12
		}
	],
	otherAssets: [
	]
};
var Encointer$2 = {
	paraId: 1001,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "KSM",
			decimals: 12
		}
	],
	otherAssets: [
	]
};
var Imbue$2 = {
	paraId: 2121,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "IMBU",
			decimals: 12
		}
	],
	otherAssets: [
	]
};
var Integritee$2 = {
	paraId: 2015,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "TEER",
			decimals: 12
		}
	],
	otherAssets: [
	]
};
var InvArchTinker$2 = {
	paraId: 2125,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "TNKR",
			decimals: 12
		}
	],
	otherAssets: [
	]
};
var Kico$2 = {
	paraId: 2107,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "KICO",
			decimals: 14
		}
	],
	otherAssets: [
		{
			assetId: "100",
			symbol: "KSM",
			decimals: 12
		},
		{
			assetId: "0",
			symbol: "KICO",
			decimals: 14
		},
		{
			assetId: "10",
			symbol: "aUSD",
			decimals: 12
		},
		{
			assetId: "11",
			symbol: "SOL",
			decimals: 12
		},
		{
			assetId: "4000000004",
			symbol: "aUSD-KSM",
			decimals: 10
		},
		{
			assetId: "4000000000",
			symbol: "KICO-aUSD",
			decimals: 10
		},
		{
			assetId: "4000000001",
			symbol: "KSM-KICO",
			decimals: 10
		},
		{
			assetId: "13",
			symbol: "LIKE",
			decimals: 12
		},
		{
			assetId: "102",
			symbol: "KAR",
			decimals: 12
		},
		{
			assetId: "4000000002",
			symbol: "KAR-KICO",
			decimals: 10
		},
		{
			assetId: "4000000003",
			symbol: "KAR-aUSD",
			decimals: 10
		},
		{
			assetId: "12",
			symbol: "LT",
			decimals: 12
		}
	]
};
var Karura$2 = {
	paraId: 2000,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "LKSM",
			decimals: 12
		},
		{
			symbol: "KAR",
			decimals: 12
		},
		{
			symbol: "BNC",
			decimals: 12
		},
		{
			symbol: "TAI",
			decimals: 12
		},
		{
			symbol: "PHA",
			decimals: 12
		},
		{
			symbol: "KINT",
			decimals: 12
		},
		{
			symbol: "VSKSM",
			decimals: 12
		},
		{
			symbol: "KSM",
			decimals: 12
		},
		{
			symbol: "aUSD",
			decimals: 12
		},
		{
			symbol: "KBTC",
			decimals: 8
		}
	],
	otherAssets: [
		{
			assetId: "0x577f6a0718a468e8a995f6075f2325f86a07c83b",
			symbol: "BUSD",
			decimals: 18
		},
		{
			assetId: "0xe278651e8ff8e2efa83d7f84205084ebc90688be",
			symbol: "BNB",
			decimals: 18
		},
		{
			assetId: "10",
			symbol: "KMA",
			decimals: 12
		},
		{
			assetId: "0x66291c7d88d2ed9a708147bae4e0814a76705e2f",
			symbol: "WBTC",
			decimals: 8
		},
		{
			assetId: "14",
			symbol: "GENS",
			decimals: 9
		},
		{
			assetId: "0",
			symbol: "taiKSM",
			decimals: 12
		},
		{
			assetId: "19",
			symbol: "LT",
			decimals: 12
		},
		{
			assetId: "0x2c7de70b32cf5f20e02329a88d2e3b00ef85eb90",
			symbol: "LINK",
			decimals: 18
		},
		{
			assetId: "8",
			symbol: "TEER",
			decimals: 12
		},
		{
			assetId: "0xb4ce1f6109854243d1af13b8ea34ed28542f31e0",
			symbol: "LDO",
			decimals: 18
		},
		{
			assetId: "16",
			symbol: "TUR",
			decimals: 10
		},
		{
			assetId: "4",
			symbol: "HKO",
			decimals: 12
		},
		{
			assetId: "6",
			symbol: "KICO",
			decimals: 14
		},
		{
			assetId: "2",
			symbol: "QTZ",
			decimals: 18
		},
		{
			assetId: "0x30b1f4ba0b07789be9986fa090a57e0fe5631ebb",
			symbol: "APE",
			decimals: 18
		},
		{
			assetId: "20",
			symbol: "LIT",
			decimals: 12
		},
		{
			assetId: "9",
			symbol: "NEER",
			decimals: 18
		},
		{
			assetId: "0xa2a37aaf4730aeedada5aa8ee20a4451cb8b1c4e",
			symbol: "MATIC",
			decimals: 18
		},
		{
			assetId: "0x77cf14f938cb97308d752647d554439d99b39a3f",
			symbol: "UNI",
			decimals: 18
		},
		{
			assetId: "1",
			symbol: "ARIS",
			decimals: 8
		},
		{
			assetId: "0",
			symbol: "RMRK",
			decimals: 10
		},
		{
			assetId: "5",
			symbol: "CSM",
			decimals: 12
		},
		{
			assetId: "0x1f3a10587a20114ea25ba1b388ee2dd4a337ce27",
			symbol: "USDCet",
			decimals: 6
		},
		{
			assetId: "17",
			symbol: "PCHU",
			decimals: 18
		},
		{
			assetId: "0x9759ca009cbcd75a84786ac19bb5d02f8e68bcd9",
			symbol: "SHIB",
			decimals: 18
		},
		{
			assetId: "13",
			symbol: "CRAB",
			decimals: 18
		},
		{
			assetId: "0x4bb6afb5fa2b07a5d1c499e1c3ddb5a15e709a71",
			symbol: "DAI",
			decimals: 18
		},
		{
			assetId: "0xc621abc3afa3f24886ea278fffa7e10e8969d755",
			symbol: "ARB",
			decimals: 18
		},
		{
			assetId: "0xece0cc38021e734bef1d5da071b027ac2f71181f",
			symbol: "WETH",
			decimals: 18
		},
		{
			assetId: "11",
			symbol: "BSX",
			decimals: 12
		},
		{
			assetId: "12",
			symbol: "AIR",
			decimals: 18
		},
		{
			assetId: "0xe20683ad1ed8bbeed7e1ae74be10f19d8045b530",
			symbol: "waUSD",
			decimals: 12
		},
		{
			assetId: "7",
			symbol: "USDT",
			decimals: 6
		},
		{
			assetId: "18",
			symbol: "SDN",
			decimals: 18
		},
		{
			assetId: "1",
			symbol: "3USD",
			decimals: 12
		},
		{
			assetId: "15",
			symbol: "EQD",
			decimals: 9
		},
		{
			assetId: "3",
			symbol: "MOVR",
			decimals: 18
		}
	]
};
var Kintsugi$2 = {
	paraId: 2092,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "KINT",
			decimals: 12
		},
		{
			symbol: "KBTC",
			decimals: 8
		},
		{
			symbol: "KSM",
			decimals: 12
		},
		{
			symbol: "INTR",
			decimals: 10
		},
		{
			symbol: "IBTC",
			decimals: 8
		},
		{
			symbol: "DOT",
			decimals: 10
		}
	],
	otherAssets: [
		{
			assetId: "5",
			symbol: "VKSM",
			decimals: 12
		},
		{
			assetId: "1",
			symbol: "AUSD",
			decimals: 12
		},
		{
			assetId: "2",
			symbol: "LKSM",
			decimals: 12
		},
		{
			assetId: "6",
			symbol: "SKSM",
			decimals: 12
		},
		{
			assetId: "3",
			symbol: "USDT",
			decimals: 6
		},
		{
			assetId: "4",
			symbol: "MOVR",
			decimals: 18
		}
	]
};
var Litmus$2 = {
	paraId: 2106,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "LIT",
			decimals: 12
		}
	],
	otherAssets: [
	]
};
var Mangata$2 = {
	paraId: 2110,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "MGX",
			decimals: 18
		}
	],
	otherAssets: [
		{
			assetId: "30",
			symbol: "USDT",
			decimals: 6
		},
		{
			assetId: "7",
			symbol: "TUR",
			decimals: 10
		},
		{
			assetId: "20",
			symbol: "TKN0x00000004-TKN0x0000000E",
			decimals: 18
		},
		{
			assetId: "13",
			symbol: "TKN0x0000000B-TKN0x00000004",
			decimals: 18
		},
		{
			assetId: "26",
			symbol: "ZLK",
			decimals: 18
		},
		{
			assetId: "5",
			symbol: "TKN0x00000004-TKN0x00000000",
			decimals: 18
		},
		{
			assetId: "8",
			symbol: "TKN0x00000000-TKN0x00000007",
			decimals: 18
		},
		{
			assetId: "33",
			symbol: "TKN0x00000000-TKN0x0000001F",
			decimals: 18
		},
		{
			assetId: "1",
			symbol: "ETH",
			decimals: 18
		},
		{
			assetId: "19",
			symbol: "TKN0x00000010-TKN0x00000004",
			decimals: 18
		},
		{
			assetId: "9",
			symbol: "TKN0x00000004-TKN0x00000007",
			decimals: 18
		},
		{
			assetId: "16",
			symbol: "vsKSM",
			decimals: 12
		},
		{
			assetId: "14",
			symbol: "BNC",
			decimals: 12
		},
		{
			assetId: "31",
			symbol: "RMRK",
			decimals: 10
		},
		{
			assetId: "21",
			symbol: "TKN0x0000000F-TKN0x00000004",
			decimals: 18
		},
		{
			assetId: "15",
			symbol: "vKSM",
			decimals: 12
		},
		{
			assetId: "24",
			symbol: "TKN0x0000000F-TKN0x00000000",
			decimals: 18
		},
		{
			assetId: "22",
			symbol: "TKN0x00000010-TKN0x0000000F",
			decimals: 18
		},
		{
			assetId: "29",
			symbol: "TKN0x00000004-TKN0x0000000E",
			decimals: 18
		},
		{
			assetId: "10",
			symbol: "TKN0x00000005-TKN0x00000000",
			decimals: 18
		},
		{
			assetId: "27",
			symbol: "TKN0x0000001A-TKN0x00000000",
			decimals: 18
		},
		{
			assetId: "28",
			symbol: "TKN0x00000004-TKN0x0000001A",
			decimals: 18
		},
		{
			assetId: "0",
			symbol: "MGX",
			decimals: 18
		},
		{
			assetId: "6",
			symbol: "KAR",
			decimals: 12
		},
		{
			assetId: "11",
			symbol: "IMBU",
			decimals: 12
		},
		{
			assetId: "3",
			symbol: "TKN0x00000000-TKN0x00000002",
			decimals: 18
		},
		{
			assetId: "17",
			symbol: "TKN0x00000000-TKN0x0000000E",
			decimals: 18
		},
		{
			assetId: "18",
			symbol: "TKN0x00000010-TKN0x00000000",
			decimals: 18
		},
		{
			assetId: "23",
			symbol: "vBNC",
			decimals: 12
		},
		{
			assetId: "4",
			symbol: "KSM",
			decimals: 12
		},
		{
			assetId: "32",
			symbol: "TKN0x00000004-TKN0x0000001E",
			decimals: 18
		},
		{
			assetId: "25",
			symbol: "TKN0x00000010-TKN0x00000000",
			decimals: 18
		},
		{
			assetId: "12",
			symbol: "TKN0x00000000-TKN0x0000000B",
			decimals: 18
		}
	]
};
var Moonriver$2 = {
	paraId: 2023,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "MOVR",
			decimals: 18
		}
	],
	otherAssets: [
		{
			assetId: "108457044225666871745333730479173774551",
			symbol: "CSM",
			decimals: 12
		},
		{
			assetId: "16797826370226091782818345603793389938",
			symbol: "SDN",
			decimals: 18
		},
		{
			assetId: "76100021443485661246318545281171740067",
			symbol: "HKO",
			decimals: 12
		},
		{
			assetId: "328179947973504579459046439826496046832",
			symbol: "KBTC",
			decimals: 8
		},
		{
			assetId: "108036400430056508975016746969135344601",
			symbol: "XRT",
			decimals: 9
		},
		{
			assetId: "213357169630950964874127107356898319277",
			symbol: "KMA",
			decimals: 12
		},
		{
			assetId: "65216491554813189869575508812319036608",
			symbol: "LIT",
			decimals: 12
		},
		{
			assetId: "173481220575862801646329923366065693029",
			symbol: "CRAB",
			decimals: 18
		},
		{
			assetId: "189307976387032586987344677431204943363",
			symbol: "PHA",
			decimals: 12
		},
		{
			assetId: "214920334981412447805621250067209749032",
			symbol: "AUSD",
			decimals: 12
		},
		{
			assetId: "175400718394635817552109270754364440562",
			symbol: "KINT",
			decimals: 12
		},
		{
			assetId: "105075627293246237499203909093923548958",
			symbol: "TEER",
			decimals: 12
		},
		{
			assetId: "311091173110107856861649819128533077277",
			symbol: "USDT",
			decimals: 6
		},
		{
			assetId: "182365888117048807484804376330534607370",
			symbol: "RMRK",
			decimals: 10
		},
		{
			assetId: "42259045809535163221576417993425387648",
			symbol: "KSM",
			decimals: 12
		},
		{
			assetId: "10810581592933651521121702237638664357",
			symbol: "KAR",
			decimals: 12
		},
		{
			assetId: "319623561105283008236062145480775032445",
			symbol: "BNC",
			decimals: 12
		}
	]
};
var ParallelHeiko$2 = {
	paraId: 2085,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "HKO",
			decimals: 12
		}
	],
	otherAssets: [
		{
			assetId: "100",
			symbol: "KSM",
			decimals: 12
		},
		{
			assetId: "123",
			symbol: "GENS",
			decimals: 9
		},
		{
			assetId: "121",
			symbol: "KBTC",
			decimals: 8
		},
		{
			assetId: "5007",
			symbol: "LP-USDT/HKO",
			decimals: 12
		},
		{
			assetId: "100210028",
			symbol: "cKSM-21/28",
			decimals: 12
		},
		{
			assetId: "125",
			symbol: "TUR",
			decimals: 10
		},
		{
			assetId: "5002",
			symbol: "LP-KSM/HKO",
			decimals: 12
		},
		{
			assetId: "103",
			symbol: "AUSD",
			decimals: 12
		},
		{
			assetId: "109",
			symbol: "LKSM",
			decimals: 12
		},
		{
			assetId: "111",
			symbol: "SDN",
			decimals: 18
		},
		{
			assetId: "5005",
			symbol: "LP-MOVR/HKO",
			decimals: 12
		},
		{
			assetId: "119",
			symbol: "KINT",
			decimals: 12
		},
		{
			assetId: "100150022",
			symbol: "cKSM-15/22",
			decimals: 12
		},
		{
			assetId: "5004",
			symbol: "LP-KSM/cKSM-20/27",
			decimals: 12
		},
		{
			assetId: "102",
			symbol: "USDT",
			decimals: 6
		},
		{
			assetId: "100230030",
			symbol: "cKSM-23/30",
			decimals: 12
		},
		{
			assetId: "5006",
			symbol: "LP-PHA/HKO",
			decimals: 12
		},
		{
			assetId: "5011",
			symbol: "LP-KBTC/HKO",
			decimals: 12
		},
		{
			assetId: "4294957295",
			symbol: "KSM_U",
			decimals: 12
		},
		{
			assetId: "1000",
			symbol: "sKSM",
			decimals: 12
		},
		{
			assetId: "113",
			symbol: "MOVR",
			decimals: 18
		},
		{
			assetId: "115",
			symbol: "PHA",
			decimals: 12
		},
		{
			assetId: "5003",
			symbol: "LP-KSM/sKSM",
			decimals: 12
		},
		{
			assetId: "100220029",
			symbol: "cKSM-22/29",
			decimals: 12
		},
		{
			assetId: "107",
			symbol: "KAR",
			decimals: 12
		},
		{
			assetId: "5008",
			symbol: "LP-KAR/HKO",
			decimals: 12
		},
		{
			assetId: "5009",
			symbol: "LP-LKSM/HKO",
			decimals: 12
		},
		{
			assetId: "5010",
			symbol: "LP-KINT/HKO",
			decimals: 12
		},
		{
			assetId: "100200027",
			symbol: "cKSM-20/27",
			decimals: 12
		}
	]
};
var Picasso$2 = {
	paraId: 2087,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "PICA",
			decimals: 12
		}
	],
	otherAssets: [
	]
};
var Pichiu$2 = {
	paraId: 2102,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "PCHU",
			decimals: 18
		}
	],
	otherAssets: [
	]
};
var Pioneer$2 = {
	paraId: 2096,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "NEER",
			decimals: 18
		}
	],
	otherAssets: [
	]
};
var Quartz$2 = {
	paraId: 2095,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "QTZ",
			decimals: 18
		}
	],
	otherAssets: [
	]
};
var Robonomics$2 = {
	paraId: 2048,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "XRT",
			decimals: 9
		}
	],
	otherAssets: [
		{
			assetId: "4294967292",
			symbol: "KAR",
			decimals: 12
		},
		{
			assetId: "4294967295",
			symbol: "KSM",
			decimals: 12
		},
		{
			assetId: "4294967291",
			symbol: "CSM",
			decimals: 12
		},
		{
			assetId: "4294967293",
			symbol: "LKSM",
			decimals: 12
		},
		{
			assetId: "4294967294",
			symbol: "AUSD",
			decimals: 12
		}
	]
};
var Shiden$2 = {
	paraId: 2007,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "SDN",
			decimals: 18
		}
	],
	otherAssets: [
		{
			assetId: "18446744073709551623",
			symbol: "PHA",
			decimals: 12
		},
		{
			assetId: "18446744073709551619",
			symbol: "LKSM",
			decimals: 12
		},
		{
			assetId: "314",
			symbol: "BAR",
			decimals: 10
		},
		{
			assetId: "18446744073709551625",
			symbol: "CRAB",
			decimals: 18
		},
		{
			assetId: "18446744073709551620",
			symbol: "MOVR",
			decimals: 18
		},
		{
			assetId: "18446744073709551621",
			symbol: "KBTC",
			decimals: 8
		},
		{
			assetId: "18446744073709551622",
			symbol: "KINT",
			decimals: 12
		},
		{
			assetId: "18446744073709551631",
			symbol: "EQD",
			decimals: 9
		},
		{
			assetId: "312",
			symbol: "XCT",
			decimals: 18
		},
		{
			assetId: "313",
			symbol: "SDG",
			decimals: 0
		},
		{
			assetId: "340282366920938463463374607431768211455",
			symbol: "KSM",
			decimals: 12
		},
		{
			assetId: "18446744073709551616",
			symbol: "aUSD",
			decimals: 12
		},
		{
			assetId: "18446744073709551624",
			symbol: "CSM",
			decimals: 12
		},
		{
			assetId: "18446744073709551618",
			symbol: "KAR",
			decimals: 12
		},
		{
			assetId: "18446744073709551630",
			symbol: "GENS",
			decimals: 9
		},
		{
			assetId: "311",
			symbol: "SYG",
			decimals: 10
		},
		{
			assetId: "18446744073709551632",
			symbol: "NEER",
			decimals: 18
		},
		{
			assetId: "18446744073709551626",
			symbol: "SKU",
			decimals: 18
		},
		{
			assetId: "18446744073709551629",
			symbol: "vsKSM",
			decimals: 12
		},
		{
			assetId: "4294969280",
			symbol: "USDT",
			decimals: 6
		},
		{
			assetId: "18446744073709551628",
			symbol: "vKSM",
			decimals: 12
		},
		{
			assetId: "18446744073709551627",
			symbol: "BNC",
			decimals: 12
		},
		{
			assetId: "315",
			symbol: "CHAI",
			decimals: 18
		}
	]
};
var Statemine$2 = {
	paraId: 1000,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "KSM",
			decimals: 12
		}
	],
	otherAssets: [
		{
			assetId: "863012",
			symbol: "VCOP",
			decimals: 2
		},
		{
			assetId: "9999",
			symbol: "BTC",
			decimals: 20
		},
		{
			assetId: "100",
			symbol: "Chralt",
			decimals: 0
		},
		{
			assetId: "123",
			symbol: "NFT",
			decimals: 20
		},
		{
			assetId: "9000",
			symbol: "KPOTS",
			decimals: 6
		},
		{
			assetId: "222",
			symbol: "PNEO",
			decimals: 12
		},
		{
			assetId: "1155",
			symbol: "WITEK",
			decimals: 18
		},
		{
			assetId: "69420",
			symbol: "CHAOS",
			decimals: 10
		},
		{
			assetId: "47",
			symbol: "EUR",
			decimals: 12
		},
		{
			assetId: "6789",
			symbol: "VHM",
			decimals: 16
		},
		{
			assetId: "50",
			symbol: "PROMO",
			decimals: 18
		},
		{
			assetId: "420",
			symbol: "BLAZE",
			decimals: 10
		},
		{
			assetId: "0",
			symbol: "DOG",
			decimals: 6
		},
		{
			assetId: "10",
			symbol: "USDC",
			decimals: 4
		},
		{
			assetId: "1111",
			symbol: "MTVD",
			decimals: 20
		},
		{
			assetId: "300",
			symbol: "PWS",
			decimals: 18
		},
		{
			assetId: "4",
			symbol: "HAPPY",
			decimals: 10
		},
		{
			assetId: "21",
			symbol: "ELEV",
			decimals: 10
		},
		{
			assetId: "333",
			symbol: "Token",
			decimals: 20
		},
		{
			assetId: "28",
			symbol: "LAC",
			decimals: 7
		},
		{
			assetId: "20",
			symbol: "BFKK",
			decimals: 20
		},
		{
			assetId: "2048",
			symbol: "RWS",
			decimals: 8
		},
		{
			assetId: "377",
			symbol: "KAA",
			decimals: 2
		},
		{
			assetId: "95834",
			symbol: "LUL",
			decimals: 12
		},
		{
			assetId: "999",
			symbol: "CBDC",
			decimals: 10
		},
		{
			assetId: "30",
			symbol: "GOL",
			decimals: 8
		},
		{
			assetId: "677",
			symbol: "GRB",
			decimals: 0
		},
		{
			assetId: "39",
			symbol: "DSCAN",
			decimals: 8
		},
		{
			assetId: "101",
			symbol: "---",
			decimals: 0
		},
		{
			assetId: "38",
			symbol: "ENT",
			decimals: 0
		},
		{
			assetId: "46",
			symbol: "FAN",
			decimals: 10
		},
		{
			assetId: "99",
			symbol: "BITCOIN",
			decimals: 20
		},
		{
			assetId: "34",
			symbol: "PLX",
			decimals: 9
		},
		{
			assetId: "7777",
			symbol: "lucky7",
			decimals: 20
		},
		{
			assetId: "168",
			symbol: "Tokens",
			decimals: 20
		},
		{
			assetId: "2077",
			symbol: "XRT",
			decimals: 8
		},
		{
			assetId: "16",
			symbol: "ARIS",
			decimals: 8
		},
		{
			assetId: "11",
			symbol: "USDT",
			decimals: 4
		},
		{
			assetId: "224",
			symbol: "SIK",
			decimals: 8
		},
		{
			assetId: "138",
			symbol: "Abc",
			decimals: 20
		},
		{
			assetId: "75",
			symbol: "cipher",
			decimals: 10
		},
		{
			assetId: "111",
			symbol: "NO1",
			decimals: 20
		},
		{
			assetId: "66",
			symbol: "DAI",
			decimals: 20
		},
		{
			assetId: "555",
			symbol: "GAME",
			decimals: 10
		},
		{
			assetId: "14",
			symbol: "DOT",
			decimals: 10
		},
		{
			assetId: "360",
			symbol: "uni",
			decimals: 20
		},
		{
			assetId: "6",
			symbol: "ZKPD",
			decimals: 10
		},
		{
			assetId: "19",
			symbol: "SHOT",
			decimals: 12
		},
		{
			assetId: "1607",
			symbol: "STRGZN",
			decimals: 0
		},
		{
			assetId: "383",
			symbol: "KODA",
			decimals: 12
		},
		{
			assetId: "42069",
			symbol: "INTRN",
			decimals: 18
		},
		{
			assetId: "88888",
			symbol: "BAILEGO",
			decimals: 0
		},
		{
			assetId: "4206969",
			symbol: "SHIB",
			decimals: 10
		},
		{
			assetId: "2021",
			symbol: "WAVE",
			decimals: 4
		},
		{
			assetId: "1107",
			symbol: "HOLIC",
			decimals: 12
		},
		{
			assetId: "77",
			symbol: "Crypto",
			decimals: 20
		},
		{
			assetId: "35",
			symbol: "LUCKY",
			decimals: 10
		},
		{
			assetId: "36",
			symbol: "RRT",
			decimals: 0
		},
		{
			assetId: "31",
			symbol: "ki",
			decimals: 18
		},
		{
			assetId: "33",
			symbol: "BUSSY",
			decimals: 10
		},
		{
			assetId: "41",
			symbol: "GOOSE",
			decimals: 12
		},
		{
			assetId: "71",
			symbol: "OAK",
			decimals: 10
		},
		{
			assetId: "44",
			symbol: "ADVNCE",
			decimals: 10
		},
		{
			assetId: "11111",
			symbol: "KVC",
			decimals: 12
		},
		{
			assetId: "15",
			symbol: "Web3",
			decimals: 20
		},
		{
			assetId: "3721",
			symbol: "fast",
			decimals: 20
		},
		{
			assetId: "374",
			symbol: "wETH",
			decimals: 18
		},
		{
			assetId: "61",
			symbol: "CRY",
			decimals: 12
		},
		{
			assetId: "40",
			symbol: "ERIC",
			decimals: 10
		},
		{
			assetId: "2",
			symbol: "PNN",
			decimals: 10
		},
		{
			assetId: "117",
			symbol: "TNKR",
			decimals: 10
		},
		{
			assetId: "70",
			symbol: "MAR",
			decimals: 5
		},
		{
			assetId: "13",
			symbol: "LN",
			decimals: 13
		},
		{
			assetId: "2049",
			symbol: "Android",
			decimals: 0
		},
		{
			assetId: "32",
			symbol: "FAV",
			decimals: 0
		},
		{
			assetId: "188",
			symbol: "ZLK",
			decimals: 12
		},
		{
			assetId: "27",
			symbol: "RUNE",
			decimals: 10
		},
		{
			assetId: "49",
			symbol: "DIAN",
			decimals: 10
		},
		{
			assetId: "1999",
			symbol: "ADVERT2",
			decimals: 10
		},
		{
			assetId: "3943",
			symbol: "GMK",
			decimals: 0
		},
		{
			assetId: "314159",
			symbol: "RTT",
			decimals: 2
		},
		{
			assetId: "29",
			symbol: "CODES",
			decimals: 10
		},
		{
			assetId: "42",
			symbol: "NRNF",
			decimals: 12
		},
		{
			assetId: "102",
			symbol: "DRX",
			decimals: 0
		},
		{
			assetId: "80815",
			symbol: "KSMFS",
			decimals: 10
		},
		{
			assetId: "43",
			symbol: "TTT",
			decimals: 2
		},
		{
			assetId: "7777777",
			symbol: "king",
			decimals: 20
		},
		{
			assetId: "365",
			symbol: "time",
			decimals: 20
		},
		{
			assetId: "5",
			symbol: "BEER",
			decimals: 12
		},
		{
			assetId: "18",
			symbol: "HEI",
			decimals: 10
		},
		{
			assetId: "7",
			symbol: "DOS",
			decimals: 1
		},
		{
			assetId: "26",
			symbol: "BUNGA",
			decimals: 8
		},
		{
			assetId: "8848",
			symbol: "top",
			decimals: 20
		},
		{
			assetId: "3077",
			symbol: "ACT",
			decimals: 0
		},
		{
			assetId: "87",
			symbol: "XEXR",
			decimals: 6
		},
		{
			assetId: "1984",
			symbol: "USDt",
			decimals: 6
		},
		{
			assetId: "2050",
			symbol: "CUT",
			decimals: 9
		},
		{
			assetId: "1688",
			symbol: "ali",
			decimals: 20
		},
		{
			assetId: "1123",
			symbol: "XEN",
			decimals: 10
		},
		{
			assetId: "4294967291",
			symbol: "PRIME",
			decimals: 7
		},
		{
			assetId: "777777",
			symbol: "DEFI",
			decimals: 8
		},
		{
			assetId: "22",
			symbol: "STH",
			decimals: 6
		},
		{
			assetId: "777",
			symbol: "GOD",
			decimals: 0
		},
		{
			assetId: "567",
			symbol: "CHRWNA",
			decimals: 10
		},
		{
			assetId: "68",
			symbol: "ADVERT",
			decimals: 10
		},
		{
			assetId: "24",
			symbol: "test",
			decimals: 1
		},
		{
			assetId: "90",
			symbol: "SATS",
			decimals: 1
		},
		{
			assetId: "80",
			symbol: "BIT",
			decimals: 0
		},
		{
			assetId: "8",
			symbol: "RMRK",
			decimals: 10
		},
		{
			assetId: "45",
			symbol: "CRIB",
			decimals: 15
		},
		{
			assetId: "841",
			symbol: "YAYOI",
			decimals: 10
		},
		{
			assetId: "5201314",
			symbol: "belove",
			decimals: 20
		},
		{
			assetId: "6967",
			symbol: "CHAOS",
			decimals: 10
		},
		{
			assetId: "1234",
			symbol: "KSM",
			decimals: 10
		},
		{
			assetId: "404",
			symbol: "MAXI",
			decimals: 8
		},
		{
			assetId: "1420",
			symbol: "HYDR",
			decimals: 10
		},
		{
			assetId: "1000",
			symbol: "SPARK",
			decimals: 10
		},
		{
			assetId: "223",
			symbol: "BILL",
			decimals: 8
		},
		{
			assetId: "60",
			symbol: "GAV",
			decimals: 4
		},
		{
			assetId: "80817",
			symbol: "FRALEY",
			decimals: 10
		},
		{
			assetId: "1",
			symbol: "L T",
			decimals: 14
		},
		{
			assetId: "12",
			symbol: "BUSD",
			decimals: 4
		},
		{
			assetId: "12345",
			symbol: "DREX",
			decimals: 10
		},
		{
			assetId: "3",
			symbol: "Meow",
			decimals: 6
		},
		{
			assetId: "55",
			symbol: "MTS",
			decimals: 8
		},
		{
			assetId: "1337",
			symbol: "TIP",
			decimals: 10
		},
		{
			assetId: "666",
			symbol: "BAD",
			decimals: 10
		},
		{
			assetId: "88",
			symbol: "BTC",
			decimals: 20
		},
		{
			assetId: "17",
			symbol: "MEME",
			decimals: 18
		},
		{
			assetId: "220204",
			symbol: "STM",
			decimals: 10
		},
		{
			assetId: "598",
			symbol: "EREN",
			decimals: 10
		},
		{
			assetId: "25",
			symbol: "BABE",
			decimals: 10
		},
		{
			assetId: "69",
			symbol: "NICE",
			decimals: 10
		},
		{
			assetId: "23",
			symbol: "KOJO",
			decimals: 3
		},
		{
			assetId: "19840",
			symbol: "USDt",
			decimals: 3
		},
		{
			assetId: "37",
			symbol: "MNCH",
			decimals: 18
		},
		{
			assetId: "759",
			symbol: "bLd",
			decimals: 18
		},
		{
			assetId: "91",
			symbol: "TMJ",
			decimals: 8
		},
		{
			assetId: "1225",
			symbol: "GOD",
			decimals: 20
		},
		{
			assetId: "64",
			symbol: "oh!",
			decimals: 4
		},
		{
			assetId: "520",
			symbol: "0xe299a5e299a5e299a5",
			decimals: 10
		},
		{
			assetId: "9",
			symbol: "TOT",
			decimals: 1
		},
		{
			assetId: "862812",
			symbol: "CUBO",
			decimals: 9
		},
		{
			assetId: "888",
			symbol: "LUCK",
			decimals: 10
		},
		{
			assetId: "911",
			symbol: "911",
			decimals: 20
		},
		{
			assetId: "214",
			symbol: "LOVE",
			decimals: 20
		},
		{
			assetId: "345",
			symbol: "345",
			decimals: 20
		},
		{
			assetId: "1441",
			symbol: "SPOT",
			decimals: 0
		},
		{
			assetId: "80816",
			symbol: "RUEPP",
			decimals: 10
		}
	]
};
var Turing$2 = {
	paraId: 2114,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "TUR",
			decimals: 10
		}
	],
	otherAssets: [
		{
			assetId: "7",
			symbol: "PHA",
			decimals: 12
		},
		{
			assetId: "5",
			symbol: "HKO",
			decimals: 12
		},
		{
			assetId: "8",
			symbol: "SDN",
			decimals: 18
		},
		{
			assetId: "1",
			symbol: "KSM",
			decimals: 12
		},
		{
			assetId: "2",
			symbol: "AUSD",
			decimals: 12
		},
		{
			assetId: "0",
			symbol: "TUR",
			decimals: 10
		},
		{
			assetId: "6",
			symbol: "SKSM",
			decimals: 12
		},
		{
			assetId: "3",
			symbol: "KAR",
			decimals: 12
		},
		{
			assetId: "4",
			symbol: "LKSM",
			decimals: 12
		}
	]
};
var Equilibrium$2 = {
	paraId: 2011,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "TOKEN",
			decimals: 9
		}
	],
	otherAssets: [
	]
};
var Unique$2 = {
	paraId: 2037,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "UNQ",
			decimals: 18
		}
	],
	otherAssets: [
	]
};
var Crust$2 = {
	paraId: 2008,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "CRU",
			decimals: 12
		}
	],
	otherAssets: [
		{
			assetId: "187224307232923873519830480073807488153",
			symbol: "EQD",
			decimals: 9
		}
	]
};
var Efinity$2 = {
	paraId: 2021,
	relayChainAssetSymbol: "DOT",
	nativeAssets: [
		{
			symbol: "EFI",
			decimals: 18
		}
	],
	otherAssets: [
	]
};
var Ipci$2 = {
	paraId: 2222,
	relayChainAssetSymbol: "KSM",
	nativeAssets: [
		{
			symbol: "MITO",
			decimals: 12
		}
	],
	otherAssets: [
	]
};
var assets = {
	Acala: Acala$2,
	Astar: Astar$2,
	BifrostPolkadot: BifrostPolkadot$2,
	Bitgreen: Bitgreen$2,
	Centrifuge: Centrifuge$2,
	Clover: Clover$2,
	ComposableFinance: ComposableFinance$2,
	Darwinia: Darwinia$2,
	HydraDX: HydraDX$2,
	Interlay: Interlay$2,
	Kylin: Kylin$2,
	Litentry: Litentry$2,
	Moonbeam: Moonbeam$2,
	Parallel: Parallel$2,
	Statemint: Statemint$2,
	Altair: Altair$2,
	Amplitude: Amplitude$2,
	Bajun: Bajun$2,
	Basilisk: Basilisk$2,
	BifrostKusama: BifrostKusama$2,
	Calamari: Calamari$2,
	Crab: Crab$2,
	CrustShadow: CrustShadow$2,
	Dorafactory: Dorafactory$2,
	Encointer: Encointer$2,
	Imbue: Imbue$2,
	Integritee: Integritee$2,
	InvArchTinker: InvArchTinker$2,
	Kico: Kico$2,
	Karura: Karura$2,
	Kintsugi: Kintsugi$2,
	Litmus: Litmus$2,
	Mangata: Mangata$2,
	Moonriver: Moonriver$2,
	ParallelHeiko: ParallelHeiko$2,
	Picasso: Picasso$2,
	Pichiu: Pichiu$2,
	Pioneer: Pioneer$2,
	Quartz: Quartz$2,
	Robonomics: Robonomics$2,
	Shiden: Shiden$2,
	Statemine: Statemine$2,
	Turing: Turing$2,
	Equilibrium: Equilibrium$2,
	Unique: Unique$2,
	Crust: Crust$2,
	Efinity: Efinity$2,
	Ipci: Ipci$2
};

var assetsMapJson = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Acala: Acala$2,
  Altair: Altair$2,
  Amplitude: Amplitude$2,
  Astar: Astar$2,
  Bajun: Bajun$2,
  Basilisk: Basilisk$2,
  BifrostKusama: BifrostKusama$2,
  BifrostPolkadot: BifrostPolkadot$2,
  Bitgreen: Bitgreen$2,
  Calamari: Calamari$2,
  Centrifuge: Centrifuge$2,
  Clover: Clover$2,
  ComposableFinance: ComposableFinance$2,
  Crab: Crab$2,
  Crust: Crust$2,
  CrustShadow: CrustShadow$2,
  Darwinia: Darwinia$2,
  Dorafactory: Dorafactory$2,
  Efinity: Efinity$2,
  Encointer: Encointer$2,
  Equilibrium: Equilibrium$2,
  HydraDX: HydraDX$2,
  Imbue: Imbue$2,
  Integritee: Integritee$2,
  Interlay: Interlay$2,
  InvArchTinker: InvArchTinker$2,
  Ipci: Ipci$2,
  Karura: Karura$2,
  Kico: Kico$2,
  Kintsugi: Kintsugi$2,
  Kylin: Kylin$2,
  Litentry: Litentry$2,
  Litmus: Litmus$2,
  Mangata: Mangata$2,
  Moonbeam: Moonbeam$2,
  Moonriver: Moonriver$2,
  Parallel: Parallel$2,
  ParallelHeiko: ParallelHeiko$2,
  Picasso: Picasso$2,
  Pichiu: Pichiu$2,
  Pioneer: Pioneer$2,
  Quartz: Quartz$2,
  Robonomics: Robonomics$2,
  Shiden: Shiden$2,
  Statemine: Statemine$2,
  Statemint: Statemint$2,
  Turing: Turing$2,
  Unique: Unique$2,
  default: assets
});

var assetsMap = assetsMapJson;
function getAssetsObject(node) {
  return assetsMap[node];
}
function getAssetId(node, symbol) {
  var info = getAssetsObject(node).otherAssets.find(function (o) {
    return o.symbol === symbol;
  });
  return info ? info.assetId : null;
}
function getRelayChainSymbol(node) {
  return getAssetsObject(node).relayChainAssetSymbol;
}
function getNativeAssets(node) {
  var info = getAssetsObject(node).nativeAssets;
  return info || [];
}
function getOtherAssets(node) {
  return getAssetsObject(node).otherAssets;
}
function getAllAssetsSymbols(node) {
  var _getAssetsObject = getAssetsObject(node),
    relayChainAssetSymbol = _getAssetsObject.relayChainAssetSymbol,
    nativeAssets = _getAssetsObject.nativeAssets,
    otherAssets = _getAssetsObject.otherAssets;
  return [relayChainAssetSymbol].concat(_toConsumableArray(nativeAssets.map(function (_ref) {
    var symbol = _ref.symbol;
    return symbol;
  })), _toConsumableArray(otherAssets.map(function (_ref2) {
    var symbol = _ref2.symbol;
    return symbol;
  })));
}
function hasSupportForAsset(node, symbol) {
  return getAllAssetsSymbols(node).includes(symbol);
}
function getAssetDecimals(node, symbol) {
  var _getAssetsObject2 = getAssetsObject(node),
    otherAssets = _getAssetsObject2.otherAssets,
    nativeAssets = _getAssetsObject2.nativeAssets;
  var asset = [].concat(_toConsumableArray(otherAssets), _toConsumableArray(nativeAssets)).find(function (o) {
    return o.symbol === symbol;
  });
  return asset ? asset.decimals : null;
}
function getParaId(node) {
  return getAssetsObject(node).paraId;
}
function getTNode(nodeID) {
  var _iterator = _createForOfIteratorHelper(NODE_NAMES),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var node = _step.value;
      if (getParaId(node) === nodeID) return node;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getAllAssetsSymbols: getAllAssetsSymbols,
  getAssetDecimals: getAssetDecimals,
  getAssetId: getAssetId,
  getAssetsObject: getAssetsObject,
  getNativeAssets: getNativeAssets,
  getOtherAssets: getOtherAssets,
  getParaId: getParaId,
  getRelayChainSymbol: getRelayChainSymbol,
  getTNode: getTNode,
  hasSupportForAsset: hasSupportForAsset
});

var supportsXTokens = function supportsXTokens(obj) {
  return 'transferXTokens' in obj;
};
var supportsPolkadotXCM = function supportsPolkadotXCM(obj) {
  return 'transferPolkadotXCM' in obj;
};
var ParachainNode = /*#__PURE__*/function () {
  function ParachainNode(node, name, type, version) {
    _classCallCheck(this, ParachainNode);
    this._name = name;
    this._type = type;
    this._node = node;
    this._version = version;
  }
  _createClass(ParachainNode, [{
    key: "name",
    get: function get() {
      return this._name;
    }
  }, {
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "node",
    get: function get() {
      return this._node;
    }
  }, {
    key: "version",
    get: function get() {
      return this._version;
    }
  }, {
    key: "transfer",
    value: function transfer(api, currencySymbol, currencyId, amount, to, destination) {
      var serializedApiCallEnabled = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var scenario = destination ? 'ParaToPara' : 'ParaToRelay';
      var paraId = destination ? getParaId(destination) : undefined;
      if (supportsXTokens(this)) {
        return this.transferXTokens({
          api: api,
          currency: currencySymbol,
          currencyID: currencyId,
          amount: amount,
          addressSelection: handleAddress(scenario, 'xTokens', api, to, this.version, paraId),
          fees: getFees(scenario),
          serializedApiCallEnabled: serializedApiCallEnabled
        });
      } else if (supportsPolkadotXCM(this)) {
        return this.transferPolkadotXCM({
          api: api,
          header: createHeaderPolkadotXCM(scenario, this.version, paraId),
          addressSelection: handleAddress(scenario, 'polkadotXCM', api, to, this.version, paraId),
          currencySelection: createCurrencySpecification(amount, scenario, this.version, this._node, currencyId),
          scenario: scenario,
          serializedApiCallEnabled: serializedApiCallEnabled
        });
      } else {
        throw new NoXCMSupportImplementedError(this._node);
      }
    }
  }]);
  return ParachainNode;
}();

var XTokensTransferImpl = /*#__PURE__*/function () {
  function XTokensTransferImpl() {
    _classCallCheck(this, XTokensTransferImpl);
  }
  _createClass(XTokensTransferImpl, null, [{
    key: "transferXTokens",
    value: function transferXTokens(_ref, currencySelection) {
      var api = _ref.api,
        amount = _ref.amount,
        addressSelection = _ref.addressSelection,
        serializedApiCallEnabled = _ref.serializedApiCallEnabled;
      var fees = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Unlimited';
      var pallet = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'XTokens';
      var module = lowercaseFirstLetter(pallet.toString());
      if (serializedApiCallEnabled) {
        return {
          module: module,
          section: 'transfer',
          parameters: [currencySelection, amount, addressSelection, fees]
        };
      }
      return api.tx[module].transfer(currencySelection, amount, addressSelection, fees);
    }
  }]);
  return XTokensTransferImpl;
}();

var Acala$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Acala, _ParachainNode);
  var _super = _createSuper(Acala);
  function Acala() {
    _classCallCheck(this, Acala);
    return _super.call(this, 'Acala', 'acala', 'polkadot', Version.V1);
  }
  _createClass(Acala, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currency = input.currency,
        currencyID = input.currencyID;
      var currencySelection = currencyID ? {
        ForeignAsset: currencyID
      } : {
        Token: currency
      };
      return XTokensTransferImpl.transferXTokens(input, currencySelection);
    }
  }]);
  return Acala;
}(ParachainNode);

var Unique$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Unique, _ParachainNode);
  var _super = _createSuper(Unique);
  function Unique() {
    _classCallCheck(this, Unique);
    return _super.call(this, 'Unique', 'unique', 'polkadot', Version.V3);
  }
  _createClass(Unique, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      return XTokensTransferImpl.transferXTokens(input, {
        ForeignAssetId: input.currencyID
      });
    }
  }]);
  return Unique;
}(ParachainNode);

// Used to inform user, that currency they wish to use is not registered on either origin or destination Parachain
var InvalidCurrencyError = /*#__PURE__*/function (_Error) {
  _inherits(InvalidCurrencyError, _Error);
  var _super = _createSuper(InvalidCurrencyError);
  function InvalidCurrencyError(message) {
    var _this;
    _classCallCheck(this, InvalidCurrencyError);
    _this = _super.call(this, message);
    _this.name = 'InvalidCurrencyError';
    return _this;
  }
  return _createClass(InvalidCurrencyError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var Crust$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Crust, _ParachainNode);
  var _super = _createSuper(Crust);
  function Crust() {
    _classCallCheck(this, Crust);
    return _super.call(this, 'Crust', 'crustParachain', 'polkadot', Version.V1);
  }
  _createClass(Crust, [{
    key: "getCurrencySelection",
    value: function getCurrencySelection(_ref) {
      var currency = _ref.currency,
        currencyID = _ref.currencyID;
      if (currency === 'CRU') {
        return 'SelfReserve';
      }
      if (!currencyID) {
        throw new InvalidCurrencyError("Asset ".concat(currency, " is not supported by node ").concat(this.node, "."));
      }
      return {
        OtherReserve: currencyID
      };
    }
  }, {
    key: "transferXTokens",
    value: function transferXTokens(input) {
      return XTokensTransferImpl.transferXTokens(input, this.getCurrencySelection(input), input.fees);
    }
  }]);
  return Crust;
}(ParachainNode);

var Efinity$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Efinity, _ParachainNode);
  var _super = _createSuper(Efinity);
  function Efinity() {
    _classCallCheck(this, Efinity);
    return _super.call(this, 'Efinity', 'efinity', 'polkadot', Version.V3);
  }
  _createClass(Efinity, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currencySelection = {
        currencyId: [0, input.currencyID]
      };
      return XTokensTransferImpl.transferXTokens(input, currencySelection);
    }
  }]);
  return Efinity;
}(ParachainNode);

var BifrostPolkadot$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(BifrostPolkadot, _ParachainNode);
  var _super = _createSuper(BifrostPolkadot);
  function BifrostPolkadot() {
    _classCallCheck(this, BifrostPolkadot);
    return _super.call(this, 'BifrostPolkadot', 'bifrost', 'polkadot', Version.V3);
  }
  _createClass(BifrostPolkadot, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      // Multiple asset options need addressing
      var currencySelection = {
        Token: input.currency
      };
      return XTokensTransferImpl.transferXTokens(input, currencySelection);
    }
  }]);
  return BifrostPolkadot;
}(ParachainNode);

var Bitgreen$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Bitgreen, _ParachainNode);
  var _super = _createSuper(Bitgreen);
  function Bitgreen() {
    _classCallCheck(this, Bitgreen);
    return _super.call(this, 'Bitgreen', 'bitgreen', 'polkadot', Version.V1);
  }
  return _createClass(Bitgreen);
}(ParachainNode);

var Centrifuge$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Centrifuge, _ParachainNode);
  var _super = _createSuper(Centrifuge);
  function Centrifuge() {
    _classCallCheck(this, Centrifuge);
    return _super.call(this, 'Centrifuge', 'centrifuge', 'polkadot', Version.V1);
  }
  _createClass(Centrifuge, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currency = input.currency,
        currencyID = input.currencyID;
      var currencySelection = currency === 'CFG' ? 'Native' : {
        ForeignAsset: currencyID
      };
      return XTokensTransferImpl.transferXTokens(input, currencySelection);
    }
  }]);
  return Centrifuge;
}(ParachainNode);

var Clover$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Clover, _ParachainNode);
  var _super = _createSuper(Clover);
  function Clover() {
    _classCallCheck(this, Clover);
    return _super.call(this, 'Clover', 'clover', 'polkadot', Version.V1);
  }
  _createClass(Clover, [{
    key: "getCurrencySelection",
    value: function getCurrencySelection(_ref) {
      var currency = _ref.currency,
        currencyID = _ref.currencyID;
      if (currency === 'CLV') {
        return 'SelfReserve';
      }
      if (!currencyID) {
        throw new InvalidCurrencyError("Asset ".concat(currency, " is not supported by node ").concat(this.node, "."));
      }
      return {
        OtherReserve: currencyID
      };
    }
  }, {
    key: "transferXTokens",
    value: function transferXTokens(input) {
      return XTokensTransferImpl.transferXTokens(input, this.getCurrencySelection(input));
    }
  }]);
  return Clover;
}(ParachainNode);

var ComposableFinance$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(ComposableFinance, _ParachainNode);
  var _super = _createSuper(ComposableFinance);
  function ComposableFinance() {
    _classCallCheck(this, ComposableFinance);
    return _super.call(this, 'ComposableFinance', 'composableFinance', 'polkadot', Version.V3);
  }
  return _createClass(ComposableFinance);
}(ParachainNode);

var HydraDX$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(HydraDX, _ParachainNode);
  var _super = _createSuper(HydraDX);
  function HydraDX() {
    _classCallCheck(this, HydraDX);
    return _super.call(this, 'HydraDX', 'hydra', 'polkadot', Version.V3);
  }
  _createClass(HydraDX, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currencyID = input.currencyID;
        input.fees;
      return XTokensTransferImpl.transferXTokens(input, currencyID);
    }
  }]);
  return HydraDX;
}(ParachainNode);

var Interlay$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Interlay, _ParachainNode);
  var _super = _createSuper(Interlay);
  function Interlay() {
    _classCallCheck(this, Interlay);
    return _super.call(this, 'Interlay', 'interlay', 'polkadot', Version.V3);
  }
  _createClass(Interlay, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currency = input.currency,
        currencyID = input.currencyID;
      var currencySelection = currencyID ? {
        ForeignAsset: currencyID
      } : {
        Token: currency
      };
      return XTokensTransferImpl.transferXTokens(input, currencySelection);
    }
  }]);
  return Interlay;
}(ParachainNode);

var Kylin$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Kylin, _ParachainNode);
  var _super = _createSuper(Kylin);
  function Kylin() {
    _classCallCheck(this, Kylin);
    return _super.call(this, 'Kylin', 'kylin', 'polkadot', Version.V1);
  }
  _createClass(Kylin, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currency = input.currency,
        fees = input.fees;
      return XTokensTransferImpl.transferXTokens(input, currency, fees, 'OrmlXTokens');
    }
  }]);
  return Kylin;
}(ParachainNode);

var Litentry$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Litentry, _ParachainNode);
  var _super = _createSuper(Litentry);
  function Litentry() {
    _classCallCheck(this, Litentry);
    return _super.call(this, 'Litentry', 'litentry', 'polkadot', Version.V1);
  }
  _createClass(Litentry, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      return XTokensTransferImpl.transferXTokens(input, 'SelfReserve');
    }
  }]);
  return Litentry;
}(ParachainNode);

var Moonbeam$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Moonbeam, _ParachainNode);
  var _super = _createSuper(Moonbeam);
  function Moonbeam() {
    _classCallCheck(this, Moonbeam);
    return _super.call(this, 'Moonbeam', 'moonbeam', 'polkadot', Version.V3);
  }
  _createClass(Moonbeam, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currency = input.currency,
        currencyID = input.currencyID;
      var currencySelection = currency === 'GLMR' ? 'SelfReserve ' : {
        ForeignAsset: currencyID
      };
      return XTokensTransferImpl.transferXTokens(input, currencySelection);
    }
  }]);
  return Moonbeam;
}(ParachainNode);

var Parallel$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Parallel, _ParachainNode);
  var _super = _createSuper(Parallel);
  function Parallel() {
    _classCallCheck(this, Parallel);
    return _super.call(this, 'Parallel', 'parallel', 'polkadot', Version.V1);
  }
  _createClass(Parallel, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      return XTokensTransferImpl.transferXTokens(input, input.currencyID);
    }
  }]);
  return Parallel;
}(ParachainNode);

var Altair$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Altair, _ParachainNode);
  var _super = _createSuper(Altair);
  function Altair() {
    _classCallCheck(this, Altair);
    return _super.call(this, 'Altair', 'altair', 'kusama', Version.V1);
  }
  _createClass(Altair, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currencySelection = Altair.getCurrencySelection(input);
      return XTokensTransferImpl.transferXTokens(input, currencySelection);
    }
  }], [{
    key: "getCurrencySelection",
    value: function getCurrencySelection(_ref) {
      var currency = _ref.currency,
        currencyID = _ref.currencyID;
      if (currency === 'AIR') return 'Native';
      if (currency === 'KSM') return currency;
      return {
        ForeignAsset: currencyID
      };
    }
  }]);
  return Altair;
}(ParachainNode);

var Amplitude$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Amplitude, _ParachainNode);
  var _super = _createSuper(Amplitude);
  function Amplitude() {
    _classCallCheck(this, Amplitude);
    return _super.call(this, 'Amplitude', 'amplitude', 'kusama', Version.V1);
  }
  _createClass(Amplitude, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      return XTokensTransferImpl.transferXTokens(input, {
        XCM: input.currency
      });
    }
  }]);
  return Amplitude;
}(ParachainNode);

var Bajun$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Bajun, _ParachainNode);
  var _super = _createSuper(Bajun);
  function Bajun() {
    _classCallCheck(this, Bajun);
    return _super.call(this, 'Bajun', 'bajun', 'kusama', Version.V1);
  }
  return _createClass(Bajun);
}(ParachainNode);

var Basilisk$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Basilisk, _ParachainNode);
  var _super = _createSuper(Basilisk);
  function Basilisk() {
    _classCallCheck(this, Basilisk);
    return _super.call(this, 'Basilisk', 'basilisk', 'kusama', Version.V3);
  }
  _createClass(Basilisk, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currencyID = input.currencyID;
      return XTokensTransferImpl.transferXTokens(input, currencyID);
    }
  }]);
  return Basilisk;
}(ParachainNode);

var BifrostKusama$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(BifrostKusama, _ParachainNode);
  var _super = _createSuper(BifrostKusama);
  function BifrostKusama() {
    _classCallCheck(this, BifrostKusama);
    return _super.call(this, 'BifrostKusama', 'bifrost', 'kusama', Version.V3);
  }
  _createClass(BifrostKusama, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      // Multiple asset options need addressing
      return XTokensTransferImpl.transferXTokens(input, {
        Token: input.currency
      });
    }
  }]);
  return BifrostKusama;
}(ParachainNode);

var Pioneer$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Pioneer, _ParachainNode);
  var _super = _createSuper(Pioneer);
  function Pioneer() {
    _classCallCheck(this, Pioneer);
    return _super.call(this, 'Pioneer', 'bitcountryPioneer', 'kusama', Version.V1);
  }
  _createClass(Pioneer, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      // Multiple asset options needs addressing
      return XTokensTransferImpl.transferXTokens(input, 'NativeToken', input.fees);
    }
  }]);
  return Pioneer;
}(ParachainNode);

var Turing$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Turing, _ParachainNode);
  var _super = _createSuper(Turing);
  function Turing() {
    _classCallCheck(this, Turing);
    return _super.call(this, 'Turing', 'turing', 'kusama', Version.V3);
  }
  _createClass(Turing, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currencyID = input.currencyID;
        input.fees;
      return XTokensTransferImpl.transferXTokens(input, currencyID);
    }
  }]);
  return Turing;
}(ParachainNode);

var Pichiu$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Pichiu, _ParachainNode);
  var _super = _createSuper(Pichiu);
  function Pichiu() {
    _classCallCheck(this, Pichiu);
    return _super.call(this, 'Pichiu', 'pichiu', 'kusama', Version.V1);
  }
  _createClass(Pichiu, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currency = input.currency,
        fees = input.fees;
      return XTokensTransferImpl.transferXTokens(input, currency, fees, 'OrmlXTokens');
    }
  }]);
  return Pichiu;
}(ParachainNode);

var Picasso$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Picasso, _ParachainNode);
  var _super = _createSuper(Picasso);
  function Picasso() {
    _classCallCheck(this, Picasso);
    return _super.call(this, 'Picasso', 'picasso', 'kusama', Version.V3);
  }
  _createClass(Picasso, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      return XTokensTransferImpl.transferXTokens(input, input.currencyID);
    }
  }]);
  return Picasso;
}(ParachainNode);

var ParallelHeiko$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(ParallelHeiko, _ParachainNode);
  var _super = _createSuper(ParallelHeiko);
  function ParallelHeiko() {
    _classCallCheck(this, ParallelHeiko);
    return _super.call(this, 'ParallelHeiko', 'heiko', 'kusama', Version.V1);
  }
  _createClass(ParallelHeiko, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      return XTokensTransferImpl.transferXTokens(input, input.currencyID);
    }
  }]);
  return ParallelHeiko;
}(ParachainNode);

var Moonriver$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Moonriver, _ParachainNode);
  var _super = _createSuper(Moonriver);
  function Moonriver() {
    _classCallCheck(this, Moonriver);
    return _super.call(this, 'Moonriver', 'moonriver', 'kusama', Version.V3);
  }
  _createClass(Moonriver, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currency = input.currency,
        currencyID = input.currencyID;
      var currencySelection = currency === 'MOVR' ? 'SelfReserve ' : {
        ForeignAsset: currencyID
      };
      return XTokensTransferImpl.transferXTokens(input, currencySelection);
    }
  }]);
  return Moonriver;
}(ParachainNode);

var Mangata$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Mangata, _ParachainNode);
  var _super = _createSuper(Mangata);
  function Mangata() {
    _classCallCheck(this, Mangata);
    return _super.call(this, 'Mangata', 'mangata', 'kusama', Version.V3);
  }
  _createClass(Mangata, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      return XTokensTransferImpl.transferXTokens(input, input.currencyID);
    }
  }]);
  return Mangata;
}(ParachainNode);

var Litmus$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Litmus, _ParachainNode);
  var _super = _createSuper(Litmus);
  function Litmus() {
    _classCallCheck(this, Litmus);
    return _super.call(this, 'Litmus', 'litmus', 'kusama', Version.V1);
  }
  _createClass(Litmus, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      // Multiple asset options needs addressing
      return XTokensTransferImpl.transferXTokens(input, 'SelfReserve');
    }
  }]);
  return Litmus;
}(ParachainNode);

var Kintsugi$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Kintsugi, _ParachainNode);
  var _super = _createSuper(Kintsugi);
  function Kintsugi() {
    _classCallCheck(this, Kintsugi);
    return _super.call(this, 'Kintsugi', 'kintsugi', 'kusama', Version.V3);
  }
  _createClass(Kintsugi, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currency = input.currency,
        currencyID = input.currencyID;
      var currencySelection = currencyID ? {
        ForeignAsset: currencyID
      } : {
        Token: currency
      };
      return XTokensTransferImpl.transferXTokens(input, currencySelection);
    }
  }]);
  return Kintsugi;
}(ParachainNode);

var Kico$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Kico, _ParachainNode);
  var _super = _createSuper(Kico);
  function Kico() {
    _classCallCheck(this, Kico);
    return _super.call(this, 'Kico', 'kico', 'kusama', Version.V1);
  }
  _createClass(Kico, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currencyID = input.currencyID,
        fees = input.fees;
      return XTokensTransferImpl.transferXTokens(input, currencyID, fees);
    }
  }]);
  return Kico;
}(ParachainNode);

var Calamari$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Calamari, _ParachainNode);
  var _super = _createSuper(Calamari);
  function Calamari() {
    _classCallCheck(this, Calamari);
    return _super.call(this, 'Calamari', 'calamari', 'kusama', Version.V1);
  }
  _createClass(Calamari, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      // Currently only option for XCM transfer
      var currencyID = input.currencyID,
        fees = input.fees;
      return XTokensTransferImpl.transferXTokens(input, {
        MantaCurrency: currencyID
      }, fees);
    }
  }]);
  return Calamari;
}(ParachainNode);

var CrustShadow$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(CrustShadow, _ParachainNode);
  var _super = _createSuper(CrustShadow);
  function CrustShadow() {
    _classCallCheck(this, CrustShadow);
    return _super.call(this, 'CrustShadow', 'shadow', 'kusama', Version.V1);
  }
  _createClass(CrustShadow, [{
    key: "getCurrencySelection",
    value: function getCurrencySelection(_ref) {
      var currency = _ref.currency,
        currencyID = _ref.currencyID;
      if (currency === 'CSM') {
        return 'SelfReserve';
      }
      if (!currencyID) {
        throw new InvalidCurrencyError("Asset ".concat(currency, " is not supported by node ").concat(this.node, "."));
      }
      return {
        OtherReserve: currencyID
      };
    }
  }, {
    key: "transferXTokens",
    value: function transferXTokens(input) {
      return XTokensTransferImpl.transferXTokens(input, this.getCurrencySelection(input));
    }
  }]);
  return CrustShadow;
}(ParachainNode);

var Dorafactory$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Dorafactory, _ParachainNode);
  var _super = _createSuper(Dorafactory);
  function Dorafactory() {
    _classCallCheck(this, Dorafactory);
    return _super.call(this, 'Dorafactory', 'dorafactory', 'kusama', Version.V1);
  }
  _createClass(Dorafactory, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currency = input.currency,
        fees = input.fees;
      return XTokensTransferImpl.transferXTokens(input, currency, fees);
    }
  }]);
  return Dorafactory;
}(ParachainNode);

var Imbue$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Imbue, _ParachainNode);
  var _super = _createSuper(Imbue);
  function Imbue() {
    _classCallCheck(this, Imbue);
    return _super.call(this, 'Imbue', 'imbue', 'kusama', Version.V3);
  }
  _createClass(Imbue, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currency = input.currency;
        input.fees;
      return XTokensTransferImpl.transferXTokens(input, currency);
    }
  }]);
  return Imbue;
}(ParachainNode);

var Integritee$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Integritee, _ParachainNode);
  var _super = _createSuper(Integritee);
  function Integritee() {
    _classCallCheck(this, Integritee);
    return _super.call(this, 'Integritee', 'integritee', 'kusama', Version.V1);
  }
  _createClass(Integritee, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      return XTokensTransferImpl.transferXTokens(input, input.currency);
    }
  }]);
  return Integritee;
}(ParachainNode);

var InvArchTinker$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(InvArchTinker, _ParachainNode);
  var _super = _createSuper(InvArchTinker);
  function InvArchTinker() {
    _classCallCheck(this, InvArchTinker);
    return _super.call(this, 'InvArchTinker', 'tinker', 'kusama', Version.V1);
  }
  _createClass(InvArchTinker, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currencyID = input.currencyID,
        fees = input.fees;
      return XTokensTransferImpl.transferXTokens(input, currencyID, fees);
    }
  }]);
  return InvArchTinker;
}(ParachainNode);

var Karura$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Karura, _ParachainNode);
  var _super = _createSuper(Karura);
  function Karura() {
    _classCallCheck(this, Karura);
    return _super.call(this, 'Karura', 'karura', 'kusama', Version.V3);
  }
  _createClass(Karura, [{
    key: "transferXTokens",
    value: function transferXTokens(input) {
      var currency = input.currency,
        currencyID = input.currencyID;
      var currencySelection = currencyID ? {
        ForeignAsset: currencyID
      } : {
        Token: currency
      };
      return XTokensTransferImpl.transferXTokens(input, currencySelection);
    }
  }]);
  return Karura;
}(ParachainNode);

// Contains basic structure of polkadotXCM call
var PolkadotXCMTransferImpl = /*#__PURE__*/function () {
  function PolkadotXCMTransferImpl() {
    _classCallCheck(this, PolkadotXCMTransferImpl);
  }
  _createClass(PolkadotXCMTransferImpl, null, [{
    key: "transferPolkadotXCM",
    value: function transferPolkadotXCM(_ref, method) {
      var api = _ref.api,
        header = _ref.header,
        addressSelection = _ref.addressSelection,
        currencySelection = _ref.currencySelection,
        serializedApiCallEnabled = _ref.serializedApiCallEnabled;
      var fees = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      if (serializedApiCallEnabled) {
        return {
          module: 'polkadotXcm',
          section: method,
          parameters: [header, addressSelection, currencySelection, 0].concat(_toConsumableArray(fees ? [fees] : []))
        };
      }
      return fees ? api.tx.polkadotXcm[method](header, addressSelection, currencySelection, 0, fees) : api.tx.polkadotXcm[method](header, addressSelection, currencySelection, 0);
    }
  }]);
  return PolkadotXCMTransferImpl;
}();

var Statemint$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Statemint, _ParachainNode);
  var _super = _createSuper(Statemint);
  function Statemint() {
    _classCallCheck(this, Statemint);
    return _super.call(this, 'Statemint', 'statemint', 'polkadot', Version.V3);
  }
  _createClass(Statemint, [{
    key: "transferPolkadotXCM",
    value: function transferPolkadotXCM(input) {
      // TESTED https://polkadot.subscan.io/xcm_message/polkadot-e4cdf1c59ffbb3d504adbc893d6b7d72665e484d
      // TESTED https://polkadot.subscan.io/xcm_message/polkadot-c01158ff1a5c5a596138ed9d0f0f2bccc1d9c51d
      var method = input.scenario === 'ParaToPara' ? 'limitedReserveTransferAssets' : 'limitedTeleportAssets';
      return PolkadotXCMTransferImpl.transferPolkadotXCM(input, method, 'Unlimited');
    }
  }]);
  return Statemint;
}(ParachainNode);

var Statemine$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Statemine, _ParachainNode);
  var _super = _createSuper(Statemine);
  function Statemine() {
    _classCallCheck(this, Statemine);
    return _super.call(this, 'Statemine', 'statemine', 'kusama', Version.V3);
  }
  _createClass(Statemine, [{
    key: "transferPolkadotXCM",
    value: function transferPolkadotXCM(input) {
      // TESTED https://kusama.subscan.io/xcm_message/kusama-ddc2a48f0d8e0337832d7aae26f6c3053e1f4ffd
      // TESTED https://kusama.subscan.io/xcm_message/kusama-8e423130a4d8b61679af95dbea18a55124f99672
      var method = input.scenario === 'ParaToPara' ? 'limitedReserveTransferAssets' : 'limitedTeleportAssets';
      return PolkadotXCMTransferImpl.transferPolkadotXCM(input, method, 'Unlimited');
    }
  }]);
  return Statemine;
}(ParachainNode);

// Used to inform user, that Parachain they wish to use does not support scenario they wish to use yet
var ScenarioNotSupportedError = /*#__PURE__*/function (_Error) {
  _inherits(ScenarioNotSupportedError, _Error);
  var _super = _createSuper(ScenarioNotSupportedError);
  function ScenarioNotSupportedError(node, scenario) {
    var _this;
    _classCallCheck(this, ScenarioNotSupportedError);
    _this = _super.call(this, "Scenario ".concat(scenario, " not supported for node ").concat(node));
    _this.name = 'ScenarioNotSupported';
    return _this;
  }
  return _createClass(ScenarioNotSupportedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var Encointer$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Encointer, _ParachainNode);
  var _super = _createSuper(Encointer);
  function Encointer() {
    _classCallCheck(this, Encointer);
    return _super.call(this, 'Encointer', 'encointer', 'kusama', Version.V1);
  }
  _createClass(Encointer, [{
    key: "transferPolkadotXCM",
    value: function transferPolkadotXCM(input) {
      // NO PARA TO PARA SCENARIOS ON SUBSCAN
      // TESTED https://encointer.subscan.io/xcm_message/kusama-418501e86e947b16c4e4e9040694017e64f9b162
      if (input.scenario === 'ParaToRelay') {
        return PolkadotXCMTransferImpl.transferPolkadotXCM(input, 'limitedTeleportAssets', 'Unlimited');
      }
      throw new ScenarioNotSupportedError(this.node, input.scenario);
    }
  }]);
  return Encointer;
}(ParachainNode);

var Robonomics$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Robonomics, _ParachainNode);
  var _super = _createSuper(Robonomics);
  function Robonomics() {
    _classCallCheck(this, Robonomics);
    return _super.call(this, 'Robonomics', 'robonomics', 'kusama', Version.V1);
  }
  _createClass(Robonomics, [{
    key: "transferPolkadotXCM",
    value: function transferPolkadotXCM(_ref) {
      var api = _ref.api,
        header = _ref.header,
        addressSelection = _ref.addressSelection,
        currencySelection = _ref.currencySelection,
        scenario = _ref.scenario;
      // TESTED https://robonomics.subscan.io/xcm_message/kusama-e9641113dae59920e5cc0e012f1510ea0e2d0455
      // TESTED https://robonomics.subscan.io/xcm_message/kusama-20b03208c99f2ef29d2d4b4cd4bc5659e54311ea
      var method = scenario === 'ParaToPara' ? 'reserveTransferAssets' : 'reserveWithdrawAssets';
      return api.tx.polkadotXcm[method](header, addressSelection, currencySelection, 0);
    }
  }]);
  return Robonomics;
}(ParachainNode);

var Astar$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Astar, _ParachainNode);
  var _super = _createSuper(Astar);
  function Astar() {
    _classCallCheck(this, Astar);
    return _super.call(this, 'Astar', 'astar', 'polkadot', Version.V3);
  }
  _createClass(Astar, [{
    key: "transferPolkadotXCM",
    value: function transferPolkadotXCM(input) {
      // TESTED https://polkadot.subscan.io/xcm_message/polkadot-f2b697df74ebe4b62853fe81b8b7d0522464972d
      var method = input.scenario === 'ParaToPara' ? 'reserveTransferAssets' : 'reserveWithdrawAssets';
      return PolkadotXCMTransferImpl.transferPolkadotXCM(input, method);
    }
  }]);
  return Astar;
}(ParachainNode);

var Equilibrium$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Equilibrium, _ParachainNode);
  var _super = _createSuper(Equilibrium);
  function Equilibrium() {
    _classCallCheck(this, Equilibrium);
    return _super.call(this, 'Equilibrium', 'equilibrium', 'polkadot', Version.V1);
  }
  _createClass(Equilibrium, [{
    key: "transferPolkadotXCM",
    value: function transferPolkadotXCM(input) {
      // UNTESTED AS 0 TX HAVE BEEN DONE FROM PARACHAIN ONLY TO PARACHAIN
      return PolkadotXCMTransferImpl.transferPolkadotXCM(input, 'reserveTransferAssets');
    }
  }]);
  return Equilibrium;
}(ParachainNode);

var Darwinia$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Darwinia, _ParachainNode);
  var _super = _createSuper(Darwinia);
  function Darwinia() {
    _classCallCheck(this, Darwinia);
    return _super.call(this, 'Darwinia', 'darwinia', 'polkadot', Version.V3);
  }
  _createClass(Darwinia, [{
    key: "transferPolkadotXCM",
    value: function transferPolkadotXCM(input) {
      // TESTED https://polkadot.subscan.io/xcm_message/polkadot-55c5c36c8fe8794c8cfbea725c9f8bc5984c6b05
      if (input.scenario === 'ParaToPara') {
        return PolkadotXCMTransferImpl.transferPolkadotXCM(input, 'reserveTransferAssets');
      }
      throw new ScenarioNotSupportedError(this.node, input.scenario);
    }
  }]);
  return Darwinia;
}(ParachainNode);

var Crab$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Crab, _ParachainNode);
  var _super = _createSuper(Crab);
  function Crab() {
    _classCallCheck(this, Crab);
    return _super.call(this, 'Crab', 'crab', 'kusama', Version.V3);
  }
  _createClass(Crab, [{
    key: "transferPolkadotXCM",
    value: function transferPolkadotXCM(input) {
      // TESTED https://kusama.subscan.io/xcm_message/kusama-ce7396ec470ba0c6516a50075046ee65464572dc
      if (input.scenario === 'ParaToPara') {
        return PolkadotXCMTransferImpl.transferPolkadotXCM(input, 'reserveTransferAssets');
      }
      throw new ScenarioNotSupportedError(this.node, input.scenario);
    }
  }]);
  return Crab;
}(ParachainNode);

var Ipci$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Ipci, _ParachainNode);
  var _super = _createSuper(Ipci);
  function Ipci() {
    _classCallCheck(this, Ipci);
    return _super.call(this, 'Ipci', 'ipci', 'kusama', Version.V1);
  }
  _createClass(Ipci, [{
    key: "transferPolkadotXCM",
    value: function transferPolkadotXCM(input) {
      // UNTESTED, ONLY HAS CHANNELS W ROBONOMICS & 0 TRANSACTIONS
      if (input.scenario === 'ParaToPara') {
        return PolkadotXCMTransferImpl.transferPolkadotXCM(input, 'reserveTransferAssets');
      }
      throw new ScenarioNotSupportedError(this.node, input.scenario);
    }
  }]);
  return Ipci;
}(ParachainNode);

var Quartz$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Quartz, _ParachainNode);
  var _super = _createSuper(Quartz);
  function Quartz() {
    _classCallCheck(this, Quartz);
    return _super.call(this, 'Quartz', 'quartz', 'kusama', Version.V3);
  }
  _createClass(Quartz, [{
    key: "transferPolkadotXCM",
    value: function transferPolkadotXCM(input) {
      // TESTED https://quartz.subscan.io/xcm_message/kusama-f5b6580f8d7f97a8d33209d2b5b34d97454587e9
      if (input.scenario === 'ParaToPara') {
        return PolkadotXCMTransferImpl.transferPolkadotXCM(input, 'reserveTransferAssets');
      }
      throw new ScenarioNotSupportedError(this.node, input.scenario);
    }
  }]);
  return Quartz;
}(ParachainNode);

var Shiden$1 = /*#__PURE__*/function (_ParachainNode) {
  _inherits(Shiden, _ParachainNode);
  var _super = _createSuper(Shiden);
  function Shiden() {
    _classCallCheck(this, Shiden);
    return _super.call(this, 'Shiden', 'shiden', 'kusama', Version.V3);
  }
  _createClass(Shiden, [{
    key: "transferPolkadotXCM",
    value: function transferPolkadotXCM(input) {
      // Same as Astar, works
      // https://shiden.subscan.io/xcm_message/kusama-97eb47c25c781affa557f36dbd117d49f7e1ab4e
      var method = input.scenario === 'ParaToPara' ? 'reserveTransferAssets' : 'reserveWithdrawAssets';
      return PolkadotXCMTransferImpl.transferPolkadotXCM(input, method);
    }
  }]);
  return Shiden;
}(ParachainNode);

// Contains supported Parachains and exports supported XCM Pallets
var NODE_NAMES = ['Statemint', 'Acala', 'Astar', 'BifrostPolkadot', 'Bitgreen', 'Centrifuge', 'Clover', 'ComposableFinance', 'Darwinia', 'HydraDX', 'Interlay', 'Kylin', 'Litentry', 'Moonbeam', 'Parallel', 'Statemine', 'Encointer', 'Altair', 'Amplitude', 'Bajun', 'Basilisk', 'BifrostKusama', 'Pioneer', 'Calamari', 'CrustShadow', 'Crab', 'Dorafactory', 'Imbue', 'Integritee', 'InvArchTinker', 'Karura', 'Kico', 'Kintsugi', 'Litmus', 'Mangata', 'Moonriver', 'ParallelHeiko', 'Picasso', 'Pichiu', 'Quartz', 'Robonomics', 'Shiden', 'Turing', 'Equilibrium', 'Unique', 'Crust', 'Efinity', 'Ipci'];
var nodes = {
  Statemint: new Statemint$1(),
  Acala: new Acala$1(),
  Astar: new Astar$1(),
  Equilibrium: new Equilibrium$1(),
  Unique: new Unique$1(),
  Crust: new Crust$1(),
  Efinity: new Efinity$1(),
  BifrostPolkadot: new BifrostPolkadot$1(),
  Bitgreen: new Bitgreen$1(),
  Centrifuge: new Centrifuge$1(),
  Clover: new Clover$1(),
  ComposableFinance: new ComposableFinance$1(),
  Darwinia: new Darwinia$1(),
  HydraDX: new HydraDX$1(),
  Interlay: new Interlay$1(),
  Kylin: new Kylin$1(),
  Litentry: new Litentry$1(),
  Moonbeam: new Moonbeam$1(),
  Parallel: new Parallel$1(),
  Statemine: new Statemine$1(),
  Encointer: new Encointer$1(),
  Altair: new Altair$1(),
  Amplitude: new Amplitude$1(),
  Bajun: new Bajun$1(),
  Basilisk: new Basilisk$1(),
  BifrostKusama: new BifrostKusama$1(),
  Pioneer: new Pioneer$1(),
  Calamari: new Calamari$1(),
  CrustShadow: new CrustShadow$1(),
  Crab: new Crab$1(),
  Dorafactory: new Dorafactory$1(),
  Imbue: new Imbue$1(),
  Integritee: new Integritee$1(),
  InvArchTinker: new InvArchTinker$1(),
  Karura: new Karura$1(),
  Kico: new Kico$1(),
  Kintsugi: new Kintsugi$1(),
  Ipci: new Ipci$1(),
  Litmus: new Litmus$1(),
  Mangata: new Mangata$1(),
  Moonriver: new Moonriver$1(),
  ParallelHeiko: new ParallelHeiko$1(),
  Picasso: new Picasso$1(),
  Pichiu: new Pichiu$1(),
  Quartz: new Quartz$1(),
  Robonomics: new Robonomics$1(),
  Shiden: new Shiden$1(),
  Turing: new Turing$1()
};
var SUPPORTED_PALLETS = ['XTokens', 'OrmlXTokens', 'PolkadotXcm', 'RelayerXcm'];

function createAccID(api, account) {
  console.log('Generating AccountId32 address');
  return api.createType('AccountId32', account).toHex();
}
function getFees(scenario) {
  if (scenario === 'ParaToRelay') {
    console.log('Asigning fees for transfer to Relay chain');
    return 4600000000;
  } else if (scenario === 'ParaToPara') {
    console.log('Asigning fees for transfer to another Parachain chain');
    return 399600000000;
  }
  throw new Error("Fees for scenario ".concat(scenario, " are not defined."));
}
function handleAddress(scenario, pallet, api, to, version, nodeId) {
  if (scenario === 'ParaToRelay' && pallet === 'xTokens') {
    console.log('AccountId32 transfer');
    if (version === Version.V3) {
      return {
        V3: {
          parents: 1,
          interior: {
            X1: {
              AccountId32: {
                id: createAccID(api, to)
              }
            }
          }
        }
      };
    }
    return {
      V1: {
        parents: 1,
        interior: {
          X1: {
            AccountId32: {
              network: 'any',
              id: createAccID(api, to)
            }
          }
        }
      }
    };
  }
  if (scenario === 'ParaToPara' && pallet === 'xTokens') {
    if (ethers.utils.isAddress(to)) {
      console.log('AccountKey20 transfer');
      if (version === Version.V3) {
        return {
          V3: {
            parents: 1,
            interior: {
              X2: [{
                Parachain: nodeId
              }, {
                AccountKey20: {
                  key: to
                }
              }]
            }
          }
        };
      }
      return {
        V1: {
          parents: 1,
          interior: {
            X2: [{
              Parachain: nodeId
            }, {
              AccountKey20: {
                network: 'Any',
                key: to
              }
            }]
          }
        }
      };
    } else {
      console.log('AccountId32 transfer');
      if (version === Version.V3) {
        return {
          V3: {
            parents: 1,
            interior: {
              X2: [{
                Parachain: nodeId
              }, {
                AccountId32: {
                  id: createAccID(api, to)
                }
              }]
            }
          }
        };
      }
      return {
        V1: {
          parents: 1,
          interior: {
            X2: [{
              Parachain: nodeId
            }, {
              AccountId32: {
                network: 'Any',
                id: createAccID(api, to)
              }
            }]
          }
        }
      };
    }
  }
  if (scenario === 'ParaToRelay' && pallet === 'polkadotXCM') {
    console.log('AccountId32 transfer');
    if (version === Version.V3) {
      return {
        V3: {
          parents: 0,
          interior: {
            X1: {
              AccountId32: {
                id: createAccID(api, to)
              }
            }
          }
        }
      };
    } else {
      return {
        V1: {
          parents: 0,
          interior: {
            X1: {
              AccountId32: {
                network: 'any',
                id: createAccID(api, to)
              }
            }
          }
        }
      };
    }
  }
  if (scenario === 'ParaToPara' && pallet === 'polkadotXCM') {
    if (ethers.utils.isAddress(to)) {
      console.log('AccountKey20 transfer');
      if (version === Version.V3) {
        return {
          V3: {
            parents: 0,
            interior: {
              X1: {
                AccountKey20: {
                  key: to
                }
              }
            }
          }
        };
      } else {
        return {
          V1: {
            parents: 0,
            interior: {
              X1: {
                AccountKey20: {
                  network: 'Any',
                  key: to
                }
              }
            }
          }
        };
      }
    } else {
      console.log('AccountId32 transfer');
      if (version === Version.V3) {
        return {
          V3: {
            parents: 0,
            interior: {
              X1: {
                AccountId32: {
                  id: createAccID(api, to)
                }
              }
            }
          }
        };
      } else {
        return {
          V1: {
            parents: 0,
            interior: {
              X1: {
                AccountId32: {
                  network: 'Any',
                  id: createAccID(api, to)
                }
              }
            }
          }
        };
      }
    }
  }
  if (scenario === 'RelayToPara') {
    if (ethers.utils.isAddress(to)) {
      console.log('AccountKey20 transfer');
      return {
        V3: {
          parents: 0,
          interior: {
            X1: {
              AccountKey20: {
                key: to
              }
            }
          }
        }
      };
    } else {
      console.log('AccountId32 transfer');
      return {
        V3: {
          parents: 0,
          interior: {
            X1: {
              AccountId32: {
                id: createAccID(api, to)
              }
            }
          }
        }
      };
    }
  }
}
function createCurrencySpecification(amount, scenario, version, node, cur) {
  if (scenario === 'ParaToRelay') {
    console.log('polkadotXCM transfer in native currency to Relay chain');
    if (version === Version.V3) {
      return {
        V3: [{
          id: {
            Concrete: {
              parents: 1,
              interior: 'Here'
            }
          },
          fun: {
            Fungible: amount
          }
        }]
      };
    } else {
      return {
        V1: [{
          id: {
            Concrete: {
              parents: 1,
              interior: 'Here'
            }
          },
          fun: {
            Fungible: amount
          }
        }]
      };
    }
  }
  if (scenario === 'RelayToPara' || scenario === 'ParaToPara') {
    console.log('polkadotXCM Native currency to sender chain transfer');
    if ((node === 'Darwinia' || node === 'Crab') && scenario === 'ParaToPara') {
      // Special case for Darwinia&Crab node
      return {
        V3: [{
          id: {
            Concrete: {
              parents: 0,
              interior: {
                X1: {
                  PalletInstance: 5
                }
              }
            }
          },
          fun: {
            Fungible: amount
          }
        }]
      };
    } else if ((node === 'Statemine' || node === 'Statemint') && scenario === 'ParaToPara') {
      // Another specific case for Statemint & Statemine to send for example USDt
      return {
        V3: [{
          id: {
            Concrete: {
              parents: 0,
              interior: {
                X2: [{
                  PalletInstance: 50
                }, {
                  GeneralIndex: cur
                }]
              }
            }
          },
          fun: {
            Fungible: amount
          }
        }]
      };
    }
    // Otherwise
    return {
      V3: [{
        id: {
          Concrete: {
            parents: 0,
            interior: 'Here'
          }
        },
        fun: {
          Fungible: amount
        }
      }]
    };
  }
}
function createHeaderPolkadotXCM(scenario, version, nodeId) {
  console.log('Generating header for polkadotXCM transfer');
  if (scenario === 'ParaToRelay') {
    if (version === Version.V3) {
      return {
        V3: {
          parents: 1,
          interior: 'Here'
        }
      };
    } else {
      return {
        V1: {
          parents: 1,
          interior: 'Here'
        }
      };
    }
  }
  if (scenario === 'ParaToPara') {
    if (version === Version.V3) {
      return {
        V3: {
          parents: 1,
          interior: {
            X1: {
              Parachain: nodeId
            }
          }
        }
      };
    } else {
      return {
        V1: {
          parents: 1,
          interior: {
            X1: {
              Parachain: nodeId
            }
          }
        }
      };
    }
  }
  if (scenario === 'RelayToPara') {
    return {
      V3: {
        parents: 0,
        interior: {
          X1: {
            Parachain: nodeId
          }
        }
      }
    };
  }
}
function getNode(node) {
  return nodes[node];
}
function getNodeEndpointOption(node) {
  var _getNode = getNode(node),
    type = _getNode.type,
    name = _getNode.name;
  var _ref = type === 'polkadot' ? prodRelayPolkadot : prodRelayKusama,
    linked = _ref.linked;
  return linked ? linked.find(function (o) {
    return o.info === name;
  }) : undefined;
}
var lowercaseFirstLetter = function lowercaseFirstLetter(str) {
  return str.charAt(0).toLowerCase() + str.slice(1);
};
var callPolkadotJsTxFunction = function callPolkadotJsTxFunction(api, _ref2) {
  var _api$tx$module;
  var module = _ref2.module,
    section = _ref2.section,
    parameters = _ref2.parameters;
  return (_api$tx$module = api.tx[module])[section].apply(_api$tx$module, _toConsumableArray(parameters));
};

var getAssetBySymbolOrId = function getAssetBySymbolOrId(node, symbolOrId) {
  var _getAssetsObject = getAssetsObject(node),
    otherAssets = _getAssetsObject.otherAssets,
    nativeAssets = _getAssetsObject.nativeAssets,
    relayChainAssetSymbol = _getAssetsObject.relayChainAssetSymbol;
  var asset = [].concat(_toConsumableArray(nativeAssets), _toConsumableArray(otherAssets)).find(function (_ref) {
    var symbol = _ref.symbol,
      assetId = _ref.assetId;
    return symbol === symbolOrId || assetId === symbolOrId;
  });
  if (asset) {
    var symbol = asset.symbol,
      assetId = asset.assetId;
    return {
      symbol: symbol,
      assetId: assetId ? Number(assetId) : undefined
    };
  }
  if (relayChainAssetSymbol === symbolOrId) return {
    symbol: relayChainAssetSymbol
  };
  return null;
};

// Used to inform user, that Parachain they wish to use is not supported yet
var NodeNotSupportedError = /*#__PURE__*/function (_Error) {
  _inherits(NodeNotSupportedError, _Error);
  var _super = _createSuper(NodeNotSupportedError);
  function NodeNotSupportedError(message) {
    var _this;
    _classCallCheck(this, NodeNotSupportedError);
    _this = _super.call(this, message);
    _this.name = 'NodeNotSupported';
    return _this;
  }
  return _createClass(NodeNotSupportedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var IncompatibleNodesError = /*#__PURE__*/function (_Error) {
  _inherits(IncompatibleNodesError, _Error);
  var _super = _createSuper(IncompatibleNodesError);
  function IncompatibleNodesError() {
    var _this;
    _classCallCheck(this, IncompatibleNodesError);
    _this = _super.call(this, 'Transactions between nodes on different relaychains are not yet possible.');
    _this.name = 'IncompatibleNodes';
    return _this;
  }
  return _createClass(IncompatibleNodesError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

// Contains basic call formatting for different XCM Palletss
var sendCommon = function sendCommon(api, origin, currencySymbolOrId, amount, to, destination) {
  var serializedApiCallEnabled = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var asset = getAssetBySymbolOrId(origin, currencySymbolOrId.toString());
  if (destination) {
    var originRelayChainSymbol = getRelayChainSymbol(origin);
    var destinationRelayChainSymbol = getRelayChainSymbol(destination);
    if (originRelayChainSymbol !== destinationRelayChainSymbol) {
      throw new IncompatibleNodesError();
    }
  }
  if (!asset) {
    throw new InvalidCurrencyError("Origin node ".concat(origin, " does not support currency or currencyId ").concat(currencySymbolOrId, "."));
  }
  if (destination && !hasSupportForAsset(destination, asset.symbol)) {
    throw new InvalidCurrencyError("Destination node ".concat(destination, " does not support currency or currencyId ").concat(currencySymbolOrId, "."));
  }
  var currencySymbol = asset.symbol,
    currencyId = asset.assetId;
  return getNode(origin).transfer(api, currencySymbol, currencyId, amount, to, destination, serializedApiCallEnabled);
};
var sendSerializedApiCall = function sendSerializedApiCall(api, origin, currencySymbolOrId, amount, to, destination) {
  return sendCommon(api, origin, currencySymbolOrId, amount, to, destination, true);
};
function send(api, origin, currencySymbolOrId, amount, to, destination) {
  return sendCommon(api, origin, currencySymbolOrId, amount, to, destination);
}
// TODO: Refactor this function
var transferRelayToParaCommon = function transferRelayToParaCommon(api, destination, amount, to) {
  var serializedApiCallEnabled = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var paraId = getParaId(destination);
  if (destination === 'Statemint' || destination === 'Statemine') {
    // Same for Statemint, Statemine and Encoiter
    var _serializedApiCall = {
      module: 'xcmPallet',
      section: 'limitedTeleportAssets',
      parameters: [createHeaderPolkadotXCM('RelayToPara', Version.V3, paraId), handleAddress('RelayToPara', '', api, to, Version.V3, paraId), createCurrencySpecification(amount, 'RelayToPara', Version.V3, destination), 0, 'Unlimited']
    };
    if (serializedApiCallEnabled) {
      return _serializedApiCall;
    }
    return callPolkadotJsTxFunction(api, _serializedApiCall);
  } else if (destination === 'Encointer') {
    var _serializedApiCall2 = {
      module: 'xcmPallet',
      section: 'limitedTeleportAssets',
      parameters: [createHeaderPolkadotXCM('RelayToPara', Version.V1, paraId), handleAddress('RelayToPara', '', api, to, Version.V1, paraId), createCurrencySpecification(amount, 'RelayToPara', Version.V1, destination), 0, 'Unlimited']
    };
    if (serializedApiCallEnabled) {
      return _serializedApiCall2;
    }
    return callPolkadotJsTxFunction(api, _serializedApiCall2);
  } else if (destination === 'Darwinia' || destination === 'Crab') {
    // Do not do anything because Darwinia and Crab does not have DOT and KSM registered
    throw new NodeNotSupportedError('These nodes do not support XCM transfers from Relay / to Relay chain.');
  }
  var serializedApiCall = {
    module: 'xcmPallet',
    section: 'reserveTransferAssets',
    parameters: [createHeaderPolkadotXCM('RelayToPara', Version.V3, paraId), handleAddress('RelayToPara', '', api, to, Version.V3, paraId), createCurrencySpecification(amount, 'RelayToPara', Version.V3, destination), 0]
  };
  if (serializedApiCallEnabled) {
    return serializedApiCall;
  }
  return callPolkadotJsTxFunction(api, serializedApiCall);
};
function transferRelayToPara(api, destination, amount, to) {
  return transferRelayToParaCommon(api, destination, amount, to);
}
var transferRelayToParaSerializedApiCall = function transferRelayToParaSerializedApiCall(api, destination, amount, to) {
  return transferRelayToParaCommon(api, destination, amount, to, true);
};

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  send: send,
  sendSerializedApiCall: sendSerializedApiCall,
  transferRelayToPara: transferRelayToPara,
  transferRelayToParaCommon: transferRelayToParaCommon,
  transferRelayToParaSerializedApiCall: transferRelayToParaSerializedApiCall
});

//Contains XYK Decentralized exchange functions implemented in collaboration with Basilisk team
function addLiquidity(api, assetA, assetB, amountA, amountBMaxLimit) {
  return api.tx.xyk.addLiquidity(assetA, assetB, amountA, amountBMaxLimit);
}
function buy(api, assetOut, assetIn, amount, maxLimit, discount) {
  return api.tx.xyk.buy(assetOut, assetIn, amount, maxLimit, discount);
}
function createPool(api, assetA, amountA, assetB, amountB) {
  return api.tx.xyk.createPool(assetA, amountA, assetB, amountB);
}
function removeLiquidity(api, assetA, assetB, liquidityAmount) {
  return api.tx.xyk.removeLiquidity(assetA, assetB, liquidityAmount);
}
function sell(api, assetIn, assetOut, amount, maxLimit, discount) {
  return api.tx.xyk.sell(assetIn, assetOut, amount, maxLimit, discount);
}

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  addLiquidity: addLiquidity,
  buy: buy,
  createPool: createPool,
  removeLiquidity: removeLiquidity,
  sell: sell
});

//Contains call formatting for opening HRMP channels functionality
function openChannel(api, origin, destination, maxSize, maxMessageSize) {
  return api.tx.sudo.sudo(api.tx.parasSudoWrapper.sudoEstablishHrmpChannel(getParaId(origin), getParaId(destination), maxSize, maxMessageSize));
}

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  openChannel: openChannel
});

//Contains call formatting for closing HRMP channels functionality
function closeChannel(api, origin, inbound, outbound) {
  return api.tx.sudo.sudo(api.tx.hrmp.forceCleanHrmp(getParaId(origin), inbound, outbound));
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  closeChannel: closeChannel
});

var AddLiquidityBuilder = /*#__PURE__*/function () {
  function AddLiquidityBuilder(api) {
    _classCallCheck(this, AddLiquidityBuilder);
    this.api = api;
  }
  _createClass(AddLiquidityBuilder, [{
    key: "assetA",
    value: function assetA(_assetA) {
      this._assetA = _assetA;
      return this;
    }
  }, {
    key: "assetB",
    value: function assetB(_assetB) {
      this._assetB = _assetB;
      return this;
    }
  }, {
    key: "amountA",
    value: function amountA(_amountA) {
      this._amountA = _amountA;
      return this;
    }
  }, {
    key: "amountBMaxLimit",
    value: function amountBMaxLimit(_amountBMaxLimit) {
      this._amountBMaxLimit = _amountBMaxLimit;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return addLiquidity(this.api, this._assetA, this._assetB, this._amountA, this._amountBMaxLimit);
    }
  }], [{
    key: "create",
    value: function create(api) {
      return new AddLiquidityBuilder(api);
    }
  }]);
  return AddLiquidityBuilder;
}();

var BuyBuilder = /*#__PURE__*/function () {
  function BuyBuilder(api) {
    _classCallCheck(this, BuyBuilder);
    this.api = api;
  }
  _createClass(BuyBuilder, [{
    key: "assetOut",
    value: function assetOut(_assetOut) {
      this._assetOut = _assetOut;
      return this;
    }
  }, {
    key: "assetIn",
    value: function assetIn(_assetIn) {
      this._assetIn = _assetIn;
      return this;
    }
  }, {
    key: "amount",
    value: function amount(_amount) {
      this._amount = _amount;
      return this;
    }
  }, {
    key: "maxLimit",
    value: function maxLimit(_maxLimit) {
      this._maxLimit = _maxLimit;
      return this;
    }
  }, {
    key: "discount",
    value: function discount(_discount) {
      this._discount = _discount;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return buy(this.api, this._assetOut, this._assetIn, this._amount, this._maxLimit, this._discount);
    }
  }], [{
    key: "create",
    value: function create(api) {
      return new BuyBuilder(api);
    }
  }]);
  return BuyBuilder;
}();

var CloseChannelBuilder = /*#__PURE__*/function () {
  function CloseChannelBuilder(api, from) {
    _classCallCheck(this, CloseChannelBuilder);
    this.api = api;
    this.from = from;
  }
  _createClass(CloseChannelBuilder, [{
    key: "inbound",
    value: function inbound(_inbound) {
      this._inbound = _inbound;
      return this;
    }
  }, {
    key: "outbound",
    value: function outbound(_outbound) {
      this._outbound = _outbound;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return closeChannel(this.api, this.from, this._inbound, this._outbound);
    }
  }], [{
    key: "create",
    value: function create(api, from) {
      return new CloseChannelBuilder(api, from);
    }
  }]);
  return CloseChannelBuilder;
}();

var CreatePoolBuilder = /*#__PURE__*/function () {
  function CreatePoolBuilder(api) {
    _classCallCheck(this, CreatePoolBuilder);
    this.api = api;
  }
  _createClass(CreatePoolBuilder, [{
    key: "assetA",
    value: function assetA(_assetA) {
      this._assetA = _assetA;
      return this;
    }
  }, {
    key: "amountA",
    value: function amountA(_amountA) {
      this._amountA = _amountA;
      return this;
    }
  }, {
    key: "assetB",
    value: function assetB(_assetB) {
      this._assetB = _assetB;
      return this;
    }
  }, {
    key: "amountB",
    value: function amountB(_amountB) {
      this._amountB = _amountB;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return createPool(this.api, this._assetA, this._amountA, this._assetB, this._amountB);
    }
  }], [{
    key: "create",
    value: function create(api) {
      return new CreatePoolBuilder(api);
    }
  }]);
  return CreatePoolBuilder;
}();

var OpenChannelBuilder = /*#__PURE__*/function () {
  function OpenChannelBuilder(api, from, to) {
    _classCallCheck(this, OpenChannelBuilder);
    this.api = api;
    this.from = from;
    this.to = to;
  }
  _createClass(OpenChannelBuilder, [{
    key: "maxSize",
    value: function maxSize(size) {
      this._maxSize = size;
      return this;
    }
  }, {
    key: "maxMessageSize",
    value: function maxMessageSize(size) {
      this._maxMessageSize = size;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return openChannel(this.api, this.from, this.to, this._maxSize, this._maxMessageSize);
    }
  }], [{
    key: "create",
    value: function create(api, from, to) {
      return new OpenChannelBuilder(api, from, to);
    }
  }]);
  return OpenChannelBuilder;
}();

var RelayToParaBuilder = /*#__PURE__*/function () {
  function RelayToParaBuilder(api, to) {
    _classCallCheck(this, RelayToParaBuilder);
    this.api = api;
    this.to = to;
  }
  _createClass(RelayToParaBuilder, [{
    key: "amount",
    value: function amount(_amount) {
      this._amount = _amount;
      return this;
    }
  }, {
    key: "address",
    value: function address(_address) {
      this._address = _address;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return transferRelayToPara(this.api, this.to, this._amount, this._address);
    }
  }, {
    key: "buildSerializedApiCall",
    value: function buildSerializedApiCall() {
      return transferRelayToParaSerializedApiCall(this.api, this.to, this._amount, this._address);
    }
  }], [{
    key: "create",
    value: function create(api, to) {
      return new RelayToParaBuilder(api, to);
    }
  }]);
  return RelayToParaBuilder;
}();

var RemoveLiquidityBuilder = /*#__PURE__*/function () {
  function RemoveLiquidityBuilder(api) {
    _classCallCheck(this, RemoveLiquidityBuilder);
    this.api = api;
  }
  _createClass(RemoveLiquidityBuilder, [{
    key: "assetA",
    value: function assetA(_assetA) {
      this._assetA = _assetA;
      return this;
    }
  }, {
    key: "assetB",
    value: function assetB(_assetB) {
      this._assetB = _assetB;
      return this;
    }
  }, {
    key: "liquidityAmount",
    value: function liquidityAmount(_liquidityAmount) {
      this._liquidityAmount = _liquidityAmount;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return removeLiquidity(this.api, this._assetA, this._assetB, this._liquidityAmount);
    }
  }], [{
    key: "create",
    value: function create(api) {
      return new RemoveLiquidityBuilder(api);
    }
  }]);
  return RemoveLiquidityBuilder;
}();

var SellBuilder = /*#__PURE__*/function () {
  function SellBuilder(api) {
    _classCallCheck(this, SellBuilder);
    this.api = api;
  }
  _createClass(SellBuilder, [{
    key: "assetIn",
    value: function assetIn(_assetIn) {
      this._assetIn = _assetIn;
      return this;
    }
  }, {
    key: "assetOut",
    value: function assetOut(_assetOut) {
      this._assetOut = _assetOut;
      return this;
    }
  }, {
    key: "amount",
    value: function amount(_amount) {
      this._amount = _amount;
      return this;
    }
  }, {
    key: "maxLimit",
    value: function maxLimit(_maxLimit) {
      this._maxLimit = _maxLimit;
      return this;
    }
  }, {
    key: "discount",
    value: function discount(_discount) {
      this._discount = _discount;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return sell(this.api, this._assetIn, this._assetOut, this._amount, this._maxLimit, this._discount);
    }
  }], [{
    key: "create",
    value: function create(api) {
      return new SellBuilder(api);
    }
  }]);
  return SellBuilder;
}();

var SendBuilder = /*#__PURE__*/function () {
  function SendBuilder(api, from, to, currency) {
    _classCallCheck(this, SendBuilder);
    this.api = api;
    this.from = from;
    this.to = to;
    this.currency = currency;
  }
  _createClass(SendBuilder, [{
    key: "amount",
    value: function amount(_amount) {
      this._amount = _amount;
      return this;
    }
  }, {
    key: "address",
    value: function address(_address) {
      this._address = _address;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return send(this.api, this.from, this.currency, this._amount, this._address, this.to);
    }
  }, {
    key: "buildSerializedApiCall",
    value: function buildSerializedApiCall() {
      return sendSerializedApiCall(this.api, this.from, this.currency, this._amount, this._address, this.to);
    }
  }], [{
    key: "createParaToRelay",
    value: function createParaToRelay(api, from, currency) {
      return new SendBuilder(api, from, undefined, currency);
    }
  }, {
    key: "createParaToPara",
    value: function createParaToPara(api, from, to, currency) {
      return new SendBuilder(api, from, to, currency);
    }
  }]);
  return SendBuilder;
}();

var ToGeneralBuilder = /*#__PURE__*/function () {
  function ToGeneralBuilder(api, from, to) {
    _classCallCheck(this, ToGeneralBuilder);
    this.api = api;
    this.from = from;
    this.to = to;
  }
  _createClass(ToGeneralBuilder, [{
    key: "currency",
    value: function currency(_currency) {
      return SendBuilder.createParaToPara(this.api, this.from, this.to, _currency);
    }
  }, {
    key: "openChannel",
    value: function openChannel() {
      return OpenChannelBuilder.create(this.api, this.from, this.to);
    }
  }]);
  return ToGeneralBuilder;
}();
var FromGeneralBuilder = /*#__PURE__*/function () {
  function FromGeneralBuilder(api, from) {
    _classCallCheck(this, FromGeneralBuilder);
    this.api = api;
    this.from = from;
  }
  _createClass(FromGeneralBuilder, [{
    key: "to",
    value: function to(node) {
      return new ToGeneralBuilder(this.api, this.from, node);
    }
  }, {
    key: "currency",
    value: function currency(_currency2) {
      return SendBuilder.createParaToRelay(this.api, this.from, _currency2);
    }
  }, {
    key: "closeChannel",
    value: function closeChannel() {
      return CloseChannelBuilder.create(this.api, this.from);
    }
  }]);
  return FromGeneralBuilder;
}();
var GeneralBuilder = /*#__PURE__*/function () {
  function GeneralBuilder(api) {
    _classCallCheck(this, GeneralBuilder);
    this.api = api;
  }
  _createClass(GeneralBuilder, [{
    key: "from",
    value: function from(node) {
      return new FromGeneralBuilder(this.api, node);
    }
  }, {
    key: "to",
    value: function to(node) {
      return RelayToParaBuilder.create(this.api, node);
    }
  }, {
    key: "addLiquidity",
    value: function addLiquidity() {
      return AddLiquidityBuilder.create(this.api);
    }
  }, {
    key: "removeLiquidity",
    value: function removeLiquidity() {
      return RemoveLiquidityBuilder.create(this.api);
    }
  }, {
    key: "buy",
    value: function buy() {
      return BuyBuilder.create(this.api);
    }
  }, {
    key: "sell",
    value: function sell() {
      return SellBuilder.create(this.api);
    }
  }, {
    key: "createPool",
    value: function createPool() {
      return CreatePoolBuilder.create(this.api);
    }
  }]);
  return GeneralBuilder;
}();
function Builder(api) {
  return new GeneralBuilder(api);
}

var Statemint = {
	defaultPallet: "PolkadotXcm",
	supportedPallets: [
		"PolkadotXcm"
	]
};
var Acala = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Astar = {
	defaultPallet: "PolkadotXcm",
	supportedPallets: [
		"PolkadotXcm"
	]
};
var BifrostPolkadot = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Bitgreen = {
	defaultPallet: "PolkadotXcm",
	supportedPallets: [
		"PolkadotXcm"
	]
};
var Centrifuge = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Clover = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var ComposableFinance = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Darwinia = {
	defaultPallet: "PolkadotXcm",
	supportedPallets: [
		"PolkadotXcm"
	]
};
var HydraDX = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Interlay = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Kylin = {
	defaultPallet: "OrmlXTokens",
	supportedPallets: [
		"PolkadotXcm",
		"OrmlXTokens"
	]
};
var Litentry = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Moonbeam = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Parallel = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Statemine = {
	defaultPallet: "PolkadotXcm",
	supportedPallets: [
		"PolkadotXcm"
	]
};
var Encointer = {
	defaultPallet: "PolkadotXcm",
	supportedPallets: [
		"PolkadotXcm"
	]
};
var Altair = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Amplitude = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Bajun = {
	defaultPallet: "PolkadotXcm",
	supportedPallets: [
		"PolkadotXcm"
	]
};
var Basilisk = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var BifrostKusama = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Pioneer = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Calamari = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var CrustShadow = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Crab = {
	defaultPallet: "PolkadotXcm",
	supportedPallets: [
		"PolkadotXcm"
	]
};
var Dorafactory = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Imbue = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Integritee = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var InvArchTinker = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Karura = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Kico = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"XTokens",
		"PolkadotXcm"
	]
};
var Kintsugi = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Litmus = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Mangata = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Moonriver = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var ParallelHeiko = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Picasso = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Pichiu = {
	defaultPallet: "OrmlXTokens",
	supportedPallets: [
		"PolkadotXcm",
		"OrmlXTokens"
	]
};
var Quartz = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"XTokens",
		"PolkadotXcm"
	]
};
var Robonomics = {
	defaultPallet: "PolkadotXcm",
	supportedPallets: [
		"PolkadotXcm"
	]
};
var Shiden = {
	defaultPallet: "PolkadotXcm",
	supportedPallets: [
		"PolkadotXcm"
	]
};
var Turing = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Equilibrium = {
	defaultPallet: "PolkadotXcm",
	supportedPallets: [
		"PolkadotXcm"
	]
};
var Unique = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"XTokens",
		"PolkadotXcm"
	]
};
var Crust = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Efinity = {
	defaultPallet: "XTokens",
	supportedPallets: [
		"PolkadotXcm",
		"XTokens"
	]
};
var Ipci = {
	defaultPallet: "PolkadotXcm",
	supportedPallets: [
		"PolkadotXcm"
	]
};
var pallets = {
	Statemint: Statemint,
	Acala: Acala,
	Astar: Astar,
	BifrostPolkadot: BifrostPolkadot,
	Bitgreen: Bitgreen,
	Centrifuge: Centrifuge,
	Clover: Clover,
	ComposableFinance: ComposableFinance,
	Darwinia: Darwinia,
	HydraDX: HydraDX,
	Interlay: Interlay,
	Kylin: Kylin,
	Litentry: Litentry,
	Moonbeam: Moonbeam,
	Parallel: Parallel,
	Statemine: Statemine,
	Encointer: Encointer,
	Altair: Altair,
	Amplitude: Amplitude,
	Bajun: Bajun,
	Basilisk: Basilisk,
	BifrostKusama: BifrostKusama,
	Pioneer: Pioneer,
	Calamari: Calamari,
	CrustShadow: CrustShadow,
	Crab: Crab,
	Dorafactory: Dorafactory,
	Imbue: Imbue,
	Integritee: Integritee,
	InvArchTinker: InvArchTinker,
	Karura: Karura,
	Kico: Kico,
	Kintsugi: Kintsugi,
	Litmus: Litmus,
	Mangata: Mangata,
	Moonriver: Moonriver,
	ParallelHeiko: ParallelHeiko,
	Picasso: Picasso,
	Pichiu: Pichiu,
	Quartz: Quartz,
	Robonomics: Robonomics,
	Shiden: Shiden,
	Turing: Turing,
	Equilibrium: Equilibrium,
	Unique: Unique,
	Crust: Crust,
	Efinity: Efinity,
	Ipci: Ipci
};

var palletsMapJson = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Acala: Acala,
  Altair: Altair,
  Amplitude: Amplitude,
  Astar: Astar,
  Bajun: Bajun,
  Basilisk: Basilisk,
  BifrostKusama: BifrostKusama,
  BifrostPolkadot: BifrostPolkadot,
  Bitgreen: Bitgreen,
  Calamari: Calamari,
  Centrifuge: Centrifuge,
  Clover: Clover,
  ComposableFinance: ComposableFinance,
  Crab: Crab,
  Crust: Crust,
  CrustShadow: CrustShadow,
  Darwinia: Darwinia,
  Dorafactory: Dorafactory,
  Efinity: Efinity,
  Encointer: Encointer,
  Equilibrium: Equilibrium,
  HydraDX: HydraDX,
  Imbue: Imbue,
  Integritee: Integritee,
  Interlay: Interlay,
  InvArchTinker: InvArchTinker,
  Ipci: Ipci,
  Karura: Karura,
  Kico: Kico,
  Kintsugi: Kintsugi,
  Kylin: Kylin,
  Litentry: Litentry,
  Litmus: Litmus,
  Mangata: Mangata,
  Moonbeam: Moonbeam,
  Moonriver: Moonriver,
  Parallel: Parallel,
  ParallelHeiko: ParallelHeiko,
  Picasso: Picasso,
  Pichiu: Pichiu,
  Pioneer: Pioneer,
  Quartz: Quartz,
  Robonomics: Robonomics,
  Shiden: Shiden,
  Statemine: Statemine,
  Statemint: Statemint,
  Turing: Turing,
  Unique: Unique,
  default: pallets
});

// Script that pulls XCM Pallets for selected Parachain
var palletsMap = palletsMapJson;
var getDefaultPallet = function getDefaultPallet(node) {
  return palletsMap[node].defaultPallet;
};
var getSupportedPallets = function getSupportedPallets(node) {
  return palletsMap[node].supportedPallets;
};

export { Builder, IncompatibleNodesError, InvalidCurrencyError, NODE_NAMES, NoXCMSupportImplementedError, NodeNotSupportedError, SUPPORTED_PALLETS, ScenarioNotSupportedError, Version, index$4 as assets, index as closeChannels, getAllAssetsSymbols, getAssetDecimals, getAssetId, getAssetsObject, getDefaultPallet, getNativeAssets, getNodeEndpointOption, getOtherAssets, getParaId, getRelayChainSymbol, getSupportedPallets, getTNode, hasSupportForAsset, index$1 as openChannels, index$3 as xcmPallet, index$2 as xyk };
